<router-outlet />
<!-- <app-hotkey-help /> -->

<div class="container-fluid mt-2" [class.distance-view]="distanceView">
  <div class="row" style="height: 100%; overflow: hidden">
    <!-- Sidebar -->
    <p-sidebar
      [(visible)]="isPatientVisible"
      position="left"
      [modal]="true"
      dismissible="true"
      data-hotkey="patient-search"
      [style]="{ width: '30vw' }"
    >
      <div class="d-flex flex-column h-100 patient-section">
        <!-- Tabs for Queue and Search -->
        <div class="sidebar-body flex-grow-1 d-flex flex-column min-h-0 overflow-hidden p-2 w-100">
          <div
            class="sidebar-tab-switch mt-2"
            data-validation-id="patient-selection"
          >
            <button
              type="button"
              class="sidebar-tab-btn"
              [class.active]="sidebarTab === 'queue'"
              (click)="sidebarTab = 'queue'"
            >
              Queue
            </button>
            <button
              type="button"
              class="sidebar-tab-btn"
              [class.active]="sidebarTab === 'search'"
              (click)="openPatientSearch()"
            >
              Search
            </button>
          </div>

          <div *ngIf="sidebarTab === 'queue'" class="sidebar-panel sidebar-panel--queue">
            <div class="queue-filter-bar mt-2 mb-2 px-2">
              <div class="d-flex flex-column gap-3 overflow-hidden py-1">
                <!-- Top Row: Type Filters + Refresh Button -->
                <div class="d-flex align-items-center justify-content-between">
                  <div
                    class="d-flex align-items-center gap-2 overflow-auto flex-nowrap"
                    style="scrollbar-width: none; -ms-overflow-style: none"
                  >
                    <button
                      class="btn btn-sm rounded-pill px-2 py-1 shadow-sm"
                      [ngStyle]="
                        queueTypeFilter === 'all'
                          ? {
                              'background-color': '#e0efff',
                              border: '1px solid #bfdbfe',
                              color: '#000',
                            }
                          : {
                              'background-color': '#ffffff',
                              border: '1px solid #e2e8f0',
                              color: '#1f2937',
                            }
                      "
                      style="
                        font-size: 11px;
                        font-weight: 500;
                        white-space: nowrap;
                        transition: 0.2s;
                      "
                      (click)="
                        queueTypeFilter = 'all'; setQueueTypeFilter('all')
                      "
                    >
                      All ({{ queue.length }})
                    </button>
                    <button
                      class="btn btn-sm rounded-pill px-2 py-1 shadow-sm"
                      [ngStyle]="
                        queueTypeFilter === 'new'
                          ? {
                              'background-color': '#e0efff',
                              border: '1px solid #bfdbfe',
                              color: '#000',
                            }
                          : {
                              'background-color': '#ffffff',
                              border: '1px solid #e2e8f0',
                              color: '#1f2937',
                            }
                      "
                      style="
                        font-size: 11px;
                        font-weight: 500;
                        white-space: nowrap;
                        transition: 0.2s;
                      "
                      (click)="
                        queueTypeFilter = 'new'; setQueueTypeFilter('new')
                      "
                    >
                      New ({{ queueNewCount }})
                    </button>
                    <button
                      class="btn btn-sm rounded-pill px-2 py-1 shadow-sm"
                      [ngStyle]="
                        queueTypeFilter === 'follow_up'
                          ? {
                              'background-color': '#e0efff',
                              border: '1px solid #bfdbfe',
                              color: '#000',
                            }
                          : {
                              'background-color': '#ffffff',
                              border: '1px solid #e2e8f0',
                              color: '#1f2937',
                            }
                      "
                      style="
                        font-size: 11px;
                        font-weight: 500;
                        white-space: nowrap;
                        transition: 0.2s;
                      "
                      (click)="
                        queueTypeFilter = 'follow_up';
                        setQueueTypeFilter('follow_up')
                      "
                    >
                      Follow Up ({{ queueFollowUpCount }})
                    </button>
                  </div>

                  <!-- Refresh Button -->
                  <button
                    class="btn btn-sm rounded-pill px-2 py-1 shadow-sm d-flex align-items-center gap-2 ms-2"
                    style="
                      background-color: #f0f9ff;
                      border: 1px solid #bae6fd;
                      color: #0369a1;
                      font-size: 11px;
                      font-weight: 500;
                      white-space: nowrap;
                    "
                    (click)="refreshQueue()"
                    [disabled]="isQueueRefreshing"
                  >
                    <i
                      class="pi pi-refresh"
                      [class.pi-spin]="isQueueRefreshing"
                      style="font-size: 12px; font-weight: 600"
                    ></i>
                    Refresh Queue
                  </button>
                </div>

                <!-- Bottom Row: Mode Filters -->
                <div
                  class="d-flex align-items-center gap-2 overflow-auto flex-nowrap"
                  style="scrollbar-width: none; -ms-overflow-style: none"
                >
                  <button
                    class="btn btn-sm rounded-pill px-2 py-1 shadow-sm"
                    [ngStyle]="
                      queueModeFilter === 'all'
                        ? {
                            'background-color': '#e0efff',
                            border: '1px solid #bfdbfe',
                            color: '#000',
                          }
                        : {
                            'background-color': '#ffffff',
                            border: '1px solid #e2e8f0',
                            color: '#1f2937',
                          }
                    "
                    style="
                      font-size: 11px;
                      font-weight: 500;
                      white-space: nowrap;
                      transition: 0.2s;
                    "
                    (click)="queueModeFilter = 'all'; setQueueModeFilter('all')"
                  >
                    All ({{ queue.length }})
                  </button>
                  <button
                    class="btn btn-sm rounded-pill px-2 py-1 shadow-sm"
                    [ngStyle]="
                      queueModeFilter === 'OPD'
                        ? {
                            'background-color': '#e0efff',
                            border: '1px solid #bfdbfe',
                            color: '#000',
                          }
                        : {
                            'background-color': '#ffffff',
                            border: '1px solid #e2e8f0',
                            color: '#1f2937',
                          }
                    "
                    style="
                      font-size: 11px;
                      font-weight: 500;
                      white-space: nowrap;
                      transition: 0.2s;
                    "
                    (click)="queueModeFilter = 'OPD'; setQueueModeFilter('OPD')"
                  >
                    OPD ({{ queueOpdCount }})
                  </button>
                  <button
                    class="btn btn-sm rounded-pill px-2 py-1 shadow-sm"
                    [ngStyle]="
                      queueModeFilter === 'COURIER'
                        ? {
                            'background-color': '#e0efff',
                            border: '1px solid #bfdbfe',
                            color: '#000',
                          }
                        : {
                            'background-color': '#ffffff',
                            border: '1px solid #e2e8f0',
                            color: '#1f2937',
                          }
                    "
                    style="
                      font-size: 11px;
                      font-weight: 500;
                      white-space: nowrap;
                      transition: 0.2s;
                    "
                    (click)="
                      queueModeFilter = 'COURIER'; setQueueModeFilter('COURIER')
                    "
                  >
                    Courier ({{ queueCourierCount }})
                  </button>
                  <button
                    class="btn btn-sm rounded-pill px-2 py-1 shadow-sm"
                    [ngStyle]="
                      queueModeFilter === 'NRI'
                        ? {
                            'background-color': '#e0efff',
                            border: '1px solid #bfdbfe',
                            color: '#000',
                          }
                        : {
                            'background-color': '#ffffff',
                            border: '1px solid #e2e8f0',
                            color: '#1f2937',
                          }
                    "
                    style="
                      font-size: 11px;
                      font-weight: 500;
                      white-space: nowrap;
                      transition: 0.2s;
                    "
                    (click)="queueModeFilter = 'NRI'; setQueueModeFilter('NRI')"
                  >
                    NRI ({{ queueNriCount }})
                  </button>
                  <button
                    class="btn btn-sm rounded-pill px-2 py-1 shadow-sm"
                    [ngStyle]="
                      queueModeFilter === 'MC'
                        ? {
                            'background-color': '#e0efff',
                            border: '1px solid #bfdbfe',
                            color: '#000',
                          }
                        : {
                            'background-color': '#ffffff',
                            border: '1px solid #e2e8f0',
                            color: '#1f2937',
                          }
                    "
                    style="
                      font-size: 11px;
                      font-weight: 500;
                      white-space: nowrap;
                      transition: 0.2s;
                    "
                    (click)="queueModeFilter = 'MC'; setQueueModeFilter('MC')"
                  >
                    MC ({{ queueMedicineCollectionCount }})
                  </button>
                </div>
              </div>
            </div>

            <!-- Now Serving (fixed above scroll) -->
            <div class="modern-queue-section modern-queue-section--serving" *ngIf="nowServingPatient">
              <div class="section-title text-success">
                <i class="pi pi-play me-2"></i>Now Serving
              </div>
              <div class="list-group list-group-flush modern-queue-list">
                <button
                  tabindex="0"
                  class="list-group-item list-group-item-action modern-queue-card active-serving"
                  (click)="selectPatientByIndex(nowServingPatient.index)"
                  [ngClass]="
                    nowServingPatient.index === queueIndex
                      ? 'selected-card'
                      : ''
                  "
                >
                  <div class="card-left-border border-green"></div>
                  <div class="card-content">
                    <div class="card-row-1">
                      <span class="queue-number"
                        >#{{ nowServingPatient.index + 1 }}</span
                      >
                      <span class="patient-name">{{
                        nowServingPatient.name | uppercase
                      }}</span>
                    </div>
                    <div class="card-row-2 text-muted">
                      <span class="visit-type">{{
                        getAppointmentTypeLabel(
                          nowServingPatient.appointment_type
                        )
                      }}</span>
                      <span
                        *ngIf="nowServingPatient.gender"
                        class="dot-separator"
                        >•</span
                      >
                      <span
                        *ngIf="nowServingPatient.gender"
                        class="metadata-label"
                        >{{ nowServingPatient.gender | titlecase }}
                        <ng-container *ngIf="nowServingPatient.age"
                          >{{ nowServingPatient.age }}y</ng-container
                        ></span
                      >
                      <span class="dot-separator">•</span>
                      <span class="wait-time text-success fw-bold"
                        >In Consultation</span
                      >
                    </div>
                    <div class="card-row-3 text-muted mt-1">
                      <span
                        class="draft-indicator"
                        pTooltip="In Consultation"
                        tooltipPosition="top"
                      >
                        <i
                          class="pi pi-play-circle text-success"
                          style="font-size: 12px"
                        ></i>
                      </span>
                      <span class="dot-separator">•</span>
                      <span class="appt-time"
                        ><i
                          class="pi pi-clock me-1"
                          style="font-size: 10px"
                        ></i
                        >{{ nowServingPatient.time }}</span
                      >
                      <span class="dot-separator">•</span>
                      <span class="mode-label"
                        ><i class="pi pi-tag me-1" style="font-size: 10px"></i
                        >{{
                          getModeTitle(nowServingPatient.is_courier)
                        }}</span
                      >
                      <span
                        *ngIf="isMedicineCollectionItem(nowServingPatient)"
                        class="dot-separator"
                        >•</span
                      >
                      <span
                        *ngIf="isMedicineCollectionItem(nowServingPatient)"
                        class="mode-label text-warning"
                        ><i class="pi pi-box me-1" style="font-size: 10px"></i
                        >MC</span
                      >
                    </div>
                  </div>
                </button>
              </div>
            </div>

            <!-- Up Next: fixed header + scrollable patient list -->
            <div
              class="modern-queue-section modern-queue-section--up-next"
              [class.mt-3]="nowServingPatient"
            >
              <div class="up-next-head">
                <span class="up-next-head__icon" aria-hidden="true">
                  <i class="pi pi-list"></i>
                </span>
                <div class="up-next-head__copy">
                  <span class="up-next-head__title">Up Next</span>
                  <span class="up-next-head__sub">Waiting to be called</span>
                </div>
              </div>
              <div class="modern-queue-list modern-queue-list--scroll">
                <ng-container *ngFor="let item of queue; let i = index">
                  <button
                    *ngIf="isQueueItemVisible(item) && i !== nowServingIndex"
                    tabindex="0"
                    (keydown.enter)="selectPatientByIndex(i)"
                    class="list-group-item list-group-item-action modern-queue-card"
                    [ngClass]="[
                      getModernStatusColorClass(item),
                      i === queueIndex ? 'selected-card' : '',
                      isNextPatient(i) ? 'next-patient-row' : '',
                    ]"
                    (click)="selectPatientByIndex(i)"
                  >
                    <div
                      class="card-left-border"
                      [ngClass]="getModernStatusColorClass(item)"
                    ></div>
                    <div class="card-content">
                      <div class="card-row-1">
                        <span class="queue-number">#{{ i + 1 }}</span>
                        <span class="patient-name">{{
                          item.name | uppercase
                        }}</span>
                        <span
                          *ngIf="isNextPatient(i)"
                          class="next-chip ms-auto"
                          title="Next patient in queue"
                          >NEXT</span
                        >
                      </div>
                      <div class="card-row-2 text-muted">
                        <span class="visit-type">{{
                          getAppointmentTypeLabel(item.appointment_type)
                        }}</span>
                        <span *ngIf="item.gender" class="dot-separator"
                          >•</span
                        >
                        <span *ngIf="item.gender" class="metadata-label"
                          >{{ item.gender | titlecase }}
                          <ng-container *ngIf="item.age"
                            >{{ item.age }}y</ng-container
                          ></span
                        >
                        <span class="dot-separator">•</span>
                        <span
                          class="wait-time"
                          [ngClass]="
                            getWaitTimeColorClass(
                              getWaitTimeLabel(item.raw_time)
                            )
                          "
                        >
                          {{ getWaitTimeLabel(item.raw_time) }}
                        </span>
                      </div>
                      <div class="card-row-3 text-muted mt-1">
                        <span
                          class="draft-indicator"
                          [pTooltip]="
                            item.status === 'assistant_doctor_done'
                              ? 'Assistant Draft Saved'
                              : 'No Draft Yet'
                          "
                          tooltipPosition="top"
                        >
                          <i
                            class="pi"
                            [ngClass]="
                              item.status === 'assistant_doctor_done'
                                ? 'pi-check-circle text-success'
                                : 'pi-circle text-400'
                            "
                            style="font-size: 12px"
                          ></i>
                        </span>
                        <span
                          class="lifecycle-label text-xs fw-semibold ms-1"
                          [ngStyle]="{
                            color:
                              item.status === 'assistant_doctor_done'
                                ? '#10b981'
                                : 'inherit',
                          }"
                        >
                          {{ getQueueLifecycleLabel(item) }}
                        </span>
                        <span class="dot-separator ms-2">•</span>
                        <span class="appt-time"
                          ><i
                            class="pi pi-clock me-1"
                            style="font-size: 10px"
                          ></i
                          >{{ item.time }}</span
                        >
                        <span class="dot-separator">•</span>
                        <span class="mode-label"
                          ><i
                            class="pi pi-tag me-1"
                            style="font-size: 10px"
                          ></i
                          >{{ getModeTitle(item.is_courier) }}</span
                        >
                        <span
                          *ngIf="isMedicineCollectionItem(item)"
                          class="dot-separator"
                          >•</span
                        >
                        <span
                          *ngIf="isMedicineCollectionItem(item)"
                          class="mode-label text-warning"
                          ><i
                            class="pi pi-box me-1"
                            style="font-size: 10px"
                          ></i
                          >MC</span
                        >
                      </div>
                    </div>
                    <div class="card-actions">
                      <div
                        class="btn btn-sm action-btn text-primary"
                        pTooltip="Select Patient"
                        (click)="
                          selectPatientByIndex(i); $event.stopPropagation()
                        "
                      >
                        <i class="pi pi-arrow-right"></i>
                      </div>
                    </div>
                  </button>
                </ng-container>
              </div>
            </div>
          </div>

          <div *ngIf="sidebarTab === 'search'" class="sidebar-panel sidebar-panel--search">
            <div class="search-visit-panel mt-2">
              <div class="search-visit-panel__head">
                <div class="search-visit-panel__icon" aria-hidden="true">
                  <i class="pi pi-users"></i>
                </div>
                <div>
                  <div class="search-visit-panel__title">Find a patient</div>
                  <div class="search-visit-panel__subtitle">
                    Search by name, number, or contact
                  </div>
                </div>
              </div>

              <div class="search-field w-100">
                <label class="search-field-label" for="patient-search-input">
                  Patient Search
                </label>
                <div class="patient-search-field">
                  <i class="pi pi-search patient-search-field__icon" aria-hidden="true"></i>
                  <p-autoComplete
                  [(ngModel)]="selectedPatient"
                  [suggestions]="patientsList"
                  (completeMethod)="searchPatients($event)"
                  (onSelect)="onPatientSelect($event)"
                  field="full_name"
                  dataKey="id"
                  inputId="patient-search-input"
                  placeholder="Search by name, number, or contact"
                  [forceSelection]="true"
                  [minLength]="1"
                  scrollHeight="320px"
                  appendTo="body"
                  [autoZIndex]="true"
                  [baseZIndex]="2000"
                  class="w-100"
                  styleClass="w-100 patient-search-ac"
                  inputStyleClass="patient-search-ac-input"
                  panelStyleClass="patient-search-ac-panel"
                  emptyMessage="No patients found"
                  (onShow)="onPatientSearchOverlayShow()"
                  (onHide)="onPatientSearchOverlayHide()"
                >
                  <ng-template let-patient pTemplate="item">
                    <div class="patient-search-item">
                      <div class="patient-search-item__avatar" aria-hidden="true">
                        {{ getPatientSearchInitials(patient) }}
                      </div>
                      <div class="patient-search-item__body">
                        <div class="patient-search-item__name">
                          {{ buildPatientDisplayName(patient) }}
                        </div>
                        <div class="patient-search-item__meta">
                          <span
                            class="patient-search-chip"
                            *ngIf="patient.patient_number"
                          >
                            <i class="pi pi-id-card"></i>
                            {{ patient.patient_number }}
                          </span>
                          <span
                            class="patient-search-chip"
                            *ngIf="patient.primary_contact"
                          >
                            <i class="pi pi-phone"></i>
                            {{ patient.primary_contact }}
                          </span>
                          <span
                            class="patient-search-chip"
                            *ngIf="patient.gender"
                          >
                            <i class="pi pi-user"></i>
                            {{ patient.gender }}
                          </span>
                        </div>
                      </div>
                      <i class="pi pi-chevron-right patient-search-item__go"></i>
                    </div>
                  </ng-template>
                  <ng-template pTemplate="empty">
                    <div class="patient-search-empty">
                      <i class="pi pi-search"></i>
                      <span>No patients found</span>
                      <small>Try a name, patient number, or contact</small>
                    </div>
                  </ng-template>
                </p-autoComplete>
                </div>
              </div>

              <div class="search-field w-100">
                <label class="search-field-label">Visit Type</label>
                <div class="search-visit-seg" role="radiogroup" aria-label="Visit Type">
                  <button
                    *ngFor="let opt of searchVisitTypeOptions"
                    type="button"
                    class="search-visit-seg__btn"
                    [class.is-active]="searchVisitType === opt.value"
                    [attr.aria-pressed]="searchVisitType === opt.value"
                    (click)="searchVisitType = opt.value"
                  >
                    <i
                      class="pi"
                      [ngClass]="{
                        'pi-bolt': opt.value === 'auto',
                        'pi-plus': opt.value === 'new',
                        'pi-replay': opt.value === 'follow_up'
                      }"
                    ></i>
                    {{ opt.label }}
                  </button>
                </div>
                <div class="search-field-hint">
                  <i class="pi pi-info-circle"></i>
                  <span *ngIf="searchVisitType === 'auto'"
                    >Auto uses patient history to choose new or follow up.</span
                  >
                  <span *ngIf="searchVisitType === 'new'"
                    >Starts this visit as a new consultation.</span
                  >
                  <span *ngIf="searchVisitType === 'follow_up'"
                    >Starts this visit as a follow up.</span
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </p-sidebar>

    <!-- CENTER PANEL -->
    <div class="col-md-12 rx-prescriptions-workspace">
      <div class="flex-grow-1 overflow-auto p-2 rx-workspace-scroll">
        <p-tabView
          styleClass="rx-main-tabview"
          [(activeIndex)]="activeIndex"
          (onChange)="onMainTabChange($event)"
          [style]="{ height: '100%' }"
        >
          <!-- Patient Card Tab -->
          <p-tabPanel>
            <ng-template pTemplate="header">
              <span class="rx-tab-link">
                <i class="pi pi-id-card"></i>
                <span>Patient Card</span>
              </span>
            </ng-template>
            <div class="rx-patient-page">
            <!-- Patient identity bar -->
            <div
              class="pc-patient-bar"
              [ngClass]="
                'pc-bar--' + (prescription.is_courier || 'OPD').toLowerCase()
              "
            >
              <div class="pc-patient-avatar"><i class="pi pi-user"></i></div>
              <div class="pc-patient-info">
                <div class="pc-patient-name">
                  {{ patient.first_name }} {{ patient.middle_name }}
                  {{ patient.last_name }}
                  <span class="pc-patient-pid" *ngIf="patient.patient_number"
                    >#{{ patient.patient_number }}</span
                  >
                </div>
                <div class="pc-patient-meta">
                  <span
                    class="pc-meta-chip pc-meta-age"
                    *ngIf="patient.age !== null && patient.age !== undefined && patient.age !== ''"
                  >
                    <i class="pi pi-calendar-clock"></i>{{ formatPatientAgeDisplay(patient.age) }} yrs
                  </span>
                  <span class="pc-meta-chip pc-meta-gender" *ngIf="patient.gender">
                    <i class="pi pi-user"></i>{{ patient.gender | titlecase }}
                  </span>
                  <span class="pc-meta-chip pc-meta-blood" *ngIf="patient.blood_group">
                    <i class="pi pi-heart-fill"></i>{{ patient.blood_group }}
                  </span>
                  <span class="pc-meta-chip pc-meta-referred" *ngIf="patient.referred_by" [title]="patient.referred_by">
                    <i class="pi pi-share-alt"></i>{{ patient.referred_by }}
                  </span>
                  <span class="pc-meta-chip pc-meta-vital" *ngIf="hasPreconsultValue(prescription.blood_pressure)">
                    <i class="pi pi-heart"></i>{{ prescription.blood_pressure }} mmHg
                  </span>
                  <span class="pc-meta-chip pc-meta-vital" *ngIf="hasPreconsultValue(prescription.pulse_rate)">
                    <i class="pi pi-wave-pulse"></i>{{ prescription.pulse_rate }} bpm
                  </span>
                  <span class="pc-meta-chip pc-meta-vital" *ngIf="hasPreconsultValue(prescription.temperature)">
                    <i class="pi pi-sun"></i>{{ prescription.temperature }}°F
                  </span>
                  <span class="pc-meta-chip pc-meta-vital" *ngIf="hasPreconsultValue(prescription.weight)">
                    <i class="pi pi-circle-fill"></i>{{ prescription.weight }} kg
                  </span>
                  <span class="pc-meta-chip pc-meta-vital" *ngIf="hasPreconsultValue(prescription.height)">
                    <i class="pi pi-arrows-v"></i>{{ prescription.height }} cm
                  </span>
                  <span class="pc-meta-chip pc-meta-vital" *ngIf="hasPreconsultValue(prescription.fasting_blood_sugar)">
                    <i class="pi pi-bolt"></i>{{ prescription.fasting_blood_sugar }} mg/dL
                  </span>
                  <span class="pc-meta-chip pc-meta-vital" *ngIf="hasPreconsultValue(prescription.blood_oxygen)">
                    <i class="pi pi-cloud"></i>{{ prescription.blood_oxygen }}%
                  </span>
                  <span class="pc-meta-chip pc-meta-free" *ngIf="patient.is_free">
                    <i class="pi pi-star-fill"></i>Free
                  </span>
                </div>
              </div>
              <div class="pc-patient-bar-actions d-flex align-items-end gap-3">
                <!-- Historical Prescription Search -->
                <div class="pc-mode-wrap pc-rx-search-wrap">
                  <span class="pc-mode-label">
                    <i class="pi pi-search me-1" style="font-size: 10px;"></i>Rx Search
                  </span>
                  <p-autoComplete
                    #historicalRxAc
                    [(ngModel)]="selectedHistoricalRx"
                    [suggestions]="historicalRxResults"
                    (completeMethod)="searchHistoricalRx($event)"
                    (onSelect)="onHistoricalRxSelect($event)"
                    optionLabel="_rxLabel"
                    dataKey="_rxKey"
                    placeholder="Search by Rx title..."
                    [forceSelection]="false"
                    [minLength]="1"
                    scrollHeight="420px"
                    appendTo="body"
                    class="w-100 pc-rx-search-ac"
                    styleClass="w-100 pc-rx-search-ac"
                    inputStyleClass="pc-rx-search-input"
                    panelStyleClass="pc-rx-search-panel"
                    emptyMessage="No prescriptions found"
                  >
                    <ng-template pTemplate="header">
                      <div
                        class="pc-rx-search-panel-head"
                        *ngIf="historicalRxSearchLoading"
                      >
                        <i class="pi pi-spin pi-spinner"></i>
                        <span>Searching prescriptions...</span>
                      </div>
                      <div
                        class="pc-rx-search-panel-head"
                        *ngIf="!historicalRxSearchLoading && historicalRxResults.length"
                      >
                        <i class="pi pi-history"></i>
                        <span>
                          {{ historicalRxResults.length }} match{{
                            historicalRxResults.length === 1 ? "" : "es"
                          }}
                        </span>
                      </div>
                    </ng-template>

                    <ng-template let-rx pTemplate="item">
                      <div
                        class="pc-rx-search-item"
                        (mousedown)="onHistoricalRxItemClick($event, rx)"
                      >
                        <div class="pc-rx-search-item__icon">
                          <i class="pi pi-file-edit"></i>
                        </div>

                        <div class="pc-rx-search-item__body">
                          <div class="pc-rx-search-item__title">
                            {{ rx.matched_title }}
                          </div>

                          <div class="pc-rx-search-item__meta">
                            <span class="pc-rx-search-chip pc-rx-search-chip--patient">
                              <i class="pi pi-user"></i>
                              {{ rx.patient_name }}
                            </span>
                            <span
                              class="pc-rx-search-chip"
                              *ngIf="rx.patient_number"
                            >
                              <i class="pi pi-id-card"></i>
                              #{{ rx.patient_number }}
                            </span>
                            <span class="pc-rx-search-chip">
                              <i class="pi pi-calendar"></i>
                              {{ rx.date }}
                            </span>
                            <span
                              class="pc-rx-search-chip pc-rx-search-chip--meds"
                              *ngIf="rx.medicine_count"
                            >
                              <i class="pi pi-box"></i>
                              {{ rx.medicine_count }}
                              med{{ rx.medicine_count === 1 ? "" : "s" }}
                            </span>
                            <span
                              class="pc-rx-search-chip pc-rx-search-chip--duration"
                              *ngIf="getHistoricalRxDuration(rx)"
                            >
                              <i class="pi pi-clock"></i>
                              {{ getHistoricalRxDuration(rx) }}
                            </span>
                          </div>

                          <div
                            class="pc-rx-search-item__preview"
                            *ngIf="getHistoricalRxMedicinePreview(rx)"
                          >
                            {{ getHistoricalRxMedicinePreview(rx) }}
                          </div>
                        </div>

                        <div class="pc-rx-search-item__action">
                          <i class="pi pi-arrow-right"></i>
                        </div>
                      </div>
                    </ng-template>

                    <ng-template pTemplate="empty">
                      <div class="pc-rx-search-empty">
                        <i class="pi pi-inbox"></i>
                        <span>No matching Rx titles</span>
                        <small>Try another keyword from a past prescription title</small>
                      </div>
                    </ng-template>

                    <ng-template pTemplate="footer">
                      <div class="pc-rx-search-panel-foot">
                        <i class="pi pi-info-circle"></i>
                        Select a result to preview and import medicines
                      </div>
                    </ng-template>
                  </p-autoComplete>
                </div>

                <div class="pc-mode-wrap">
                  <span class="pc-mode-label">Mode</span>
                  <p-dropdown
                    [options]="prescriptionModeOptions"
                    [(ngModel)]="prescription.is_courier"
                    optionLabel="label"
                    optionValue="value"
                    styleClass="pc-mode-dd"
                    appendTo="body"
                  ></p-dropdown>
                </div>
                <button
                  class="pc-notes-btn pc-add-patient-btn"
                  (click)="openAddPatientDialog()"
                  title="Add New Patient"
                >
                  <i class="pi pi-user-plus"></i><span>Add Patient</span>
                </button>
              </div>
            </div>

            <div class="rx-patient-content">
              <!-- <div class="row g-2" style="margin-top: 10px; justify-content: space-evenly; ">
                  <div class="col-md-4">
                  </div>
                </div> -->

              <!-- <hr style="margin-top: auto;"> -->

              <!-- ══════════════════════════════════════════════════════════
                   Clinical Workspace — Unified AI-integrated panel
                   Left: Input fields  |  Right: Live AI Copilot
                   ══════════════════════════════════════════════════════════ -->
              <div
                class="rx-cw"
                [class.rx-cw--no-ai]="!aiEnabled"
                data-validation-id="chief-complaints"
              >
                <!-- Workspace Header -->
                <div class="rx-cw__header">
                  <span class="rx-cw__header-icon">
                    <i class="pi pi-clipboard"></i>
                  </span>
                  <span class="rx-cw__header-title">Clinical Workspace</span>
                  <span
                    class="rx-cw__header-badge"
                    *ngIf="
                      aiEnabled &&
                      (!prescription.chief_complaints || !diagnosisTags?.length)
                    "
                  >
                    <i class="pi pi-exclamation-circle"></i> Incomplete
                  </span>
                  <span
                    class="rx-cw__header-badge rx-cw__header-badge--ok"
                    *ngIf="
                      aiEnabled &&
                      prescription.chief_complaints &&
                      diagnosisTags.length
                    "
                  >
                    <i class="pi pi-check-circle"></i> Ready
                  </span>
                </div>

                <!-- Two-column body -->
                <div class="rx-cw__body">
                  <!-- ── LEFT: Input Fields ── -->
                  <div class="rx-cw__inputs">
                    <!-- Chief Complaints -->
                    <div
                      class="rx-cw__field rx-cw__field--cc"
                      [class.rx-cw__field--active]="
                        prescription.chief_complaints?.length
                      "
                    >
                      <div class="rx-cw__field-label">
                        <span class="rx-cw__field-icon rx-cw__field-icon--cc">
                          <i class="pi pi-comment"></i>
                        </span>
                        Chief Complaints
                        <span class="rx-cw__field-required">*</span>
                      </div>
                      <textarea
                        #ccTextarea
                        class="rx-cw__textarea"
                        appAutoCapitalize
                        placeholder="Describe the patient's main complaints…"
                        rows="5"
                        [(ngModel)]="prescription.chief_complaints"
                        (keydown)="onChiefComplaintKeydown($event)"
                        (blur)="onChiefComplaintsBlur()"
                      ></textarea>
                      <div
                        class="rx-cw__char-count"
                        *ngIf="prescription.chief_complaints?.length"
                      >
                        {{ prescription.chief_complaints.length }} chars
                      </div>
                    </div>

                    <!-- Divider -->
                    <div class="rx-cw__divider"></div>

                    <!-- Diagnosis -->
                    <div
                      class="rx-cw__field rx-cw__field--dx"
                      [class.rx-cw__field--active]="diagnosisTags.length"
                      data-validation-id="diagnosis"
                    >
                      <div class="rx-cw__field-label">
                        <span class="rx-cw__field-icon rx-cw__field-icon--dx">
                          <i class="pi pi-bookmark"></i>
                        </span>
                        Diagnosis
                        <span class="rx-cw__field-required">*</span>
                        <span
                          class="rx-cw__field-count"
                          *ngIf="diagnosisTags?.length"
                        >
                          {{ diagnosisTags.length }}
                        </span>
                      </div>

                      <!-- Input composer -->
                      <div class="rx-cw__composer">
                        <i class="pi pi-search rx-cw__composer-icon"></i>
                        <input
                          type="text"
                          class="rx-cw__composer-input"
                          placeholder="Type to search or add diagnosis…"
                          [(ngModel)]="diagnosisInput"
                          (input)="onDiagnosisInputChange()"
                          (keydown)="handleDiagnosisComposerKeydown($event)"
                        />
                      </div>

                      <!-- Filtered suggestions dropdown -->
                      <div
                        class="rx-cw__suggestions"
                        *ngIf="filteredDiagnoses.length"
                      >
                        <button
                          type="button"
                          class="rx-cw__suggestion-item"
                          [class.rx-cw__suggestion-item--active]="
                            i === diagnosisSuggestionIndex
                          "
                          *ngFor="let item of filteredDiagnoses; let i = index"
                          (click)="addDiagnosisTag(item)"
                        >
                          <i class="pi pi-plus-circle"></i>
                          {{ item.diagnosis || item }}
                        </button>
                      </div>

                      <!-- Selected chips -->
                      <div class="rx-cw__chips" *ngIf="diagnosisTags?.length">
                        <span
                          class="rx-cw__chip rx-cw__chip--dx"
                          *ngFor="let tag of diagnosisTags"
                        >
                          <i class="pi pi-tag"></i>
                          {{ tag.diagnosis || tag }}
                          <button
                            type="button"
                            class="rx-cw__chip-remove"
                            (click)="removeDiagnosisTag(tag)"
                            aria-label="Remove diagnosis"
                          >
                            ×
                          </button>
                        </span>
                      </div>
                      <div
                        class="rx-cw__field-empty"
                        *ngIf="
                          aiEnabled &&
                          !diagnosisTags?.length &&
                          !filteredDiagnoses.length
                        "
                      >
                        No diagnosis added — type above or use AI suggestions →
                      </div>
                    </div>

                    <!-- Divider -->
                    <div class="rx-cw__divider"></div>

                    <!-- Suggested Reports -->
                    <div class="rx-cw__field rx-cw__field--rep">
                      <div class="rx-cw__field-label">
                        <span class="rx-cw__field-icon rx-cw__field-icon--rep">
                          <i class="pi pi-file-pdf"></i>
                        </span>
                        Suggested Reports
                        <span class="rx-cw__field-optional">Optional</span>
                        <span
                          class="rx-cw__field-count"
                          *ngIf="reportTags?.length"
                        >
                          {{ reportTags.length }}
                        </span>
                      </div>

                      <!-- Input composer -->
                      <div class="rx-cw__composer">
                        <i class="pi pi-file-edit rx-cw__composer-icon"></i>
                        <input
                          type="text"
                          class="rx-cw__composer-input"
                          placeholder="Type report name and press Enter…"
                          [(ngModel)]="prescription.suggested_reports"
                          (input)="onReportInputChange()"
                          (keydown)="handleReportComposerKeydown($event)"
                        />
                      </div>

                      <!-- Filtered suggestions -->
                      <div
                        class="rx-cw__suggestions"
                        *ngIf="filteredReports.length"
                      >
                        <button
                          type="button"
                          class="rx-cw__suggestion-item rx-cw__suggestion-item--rep"
                          [class.rx-cw__suggestion-item--active]="
                            i === reportSuggestionIndex
                          "
                          *ngFor="let item of filteredReports; let i = index"
                          (click)="addReportTag(item)"
                        >
                          <i class="pi pi-plus-circle"></i>
                          {{ formatTagDisplay(item) }}
                        </button>
                      </div>

                      <!-- Selected chips -->
                      <div class="rx-cw__chips" *ngIf="reportTags?.length">
                        <span
                          class="rx-cw__chip rx-cw__chip--rep"
                          *ngFor="let tag of reportTags"
                        >
                          <i class="pi pi-flask"></i>
                          {{ formatTagDisplay(tag) }}
                          <button
                            type="button"
                            class="rx-cw__chip-remove"
                            (click)="removeReportTag(tag)"
                            aria-label="Remove report"
                          >
                            ×
                          </button>
                        </span>
                      </div>
                    </div>
                  </div>
                  <!-- /rx-cw__inputs -->

                  <!-- ── RIGHT: AI Copilot ── -->
                  <div class="rx-cw__ai-panel" *ngIf="aiEnabled">
                    <app-chief-complaint-assistant
                      #ccAssistant
                      [symptoms]="prescription.chief_complaints"
                      [patientId]="patient?.patient_id ?? null"
                      [clinicId]="clinicId || null"
                      [patientContext]="{
                        age: patient?.age,
                        gender: patient?.gender,
                        blood_pressure: prescription?.blood_pressure,
                        pulse_rate: prescription?.pulse_rate,
                        temperature: prescription?.temperature,
                        weight: prescription?.weight,
                        height: prescription?.height,
                      }"
                      (addDiagnosis)="addDiagnosisTag({ diagnosis: $event })"
                      (addNote)="appendToChiefComplaints($event)"
                      (addReport)="addReportByName($event)"
                    ></app-chief-complaint-assistant>

                    <!-- Empty state when no symptoms typed -->
                    <div
                      class="rx-cw__ai-empty"
                      *ngIf="!prescription.chief_complaints?.trim()"
                    >
                      <div class="rx-cw__ai-empty-icon">
                        <i class="pi pi-sparkles"></i>
                      </div>
                      <div class="rx-cw__ai-empty-title">
                        AI Clinical Copilot
                      </div>
                      <div class="rx-cw__ai-empty-sub">
                        Start typing chief complaints to activate real-time AI
                        clinical support — differential diagnoses, follow-up
                        questions, red flags, and suggested reports will appear
                        here.
                      </div>
                    </div>
                  </div>
                  <!-- /rx-cw__ai-panel -->
                </div>
                <!-- /rx-cw__body -->
              </div>
              <!-- /rx-cw -->

              <!-- Rx Prescription Cards below -->

              <!-- <pre>{{ prescription.prescriptions | json }}</pre> -->
              <div
                *ngFor="let pres of prescription.prescriptions; let i = index"
                class="rx-draggable-card"
                [class.rx-draggable-card-dragging]="draggingRxIndex === i"
                [class.rx-draggable-card-over]="dragOverRxIndex === i"
                draggable="true"
                (dragstart)="onRxDragStart(i, $event)"
                (dragover)="onRxDragOver(i, $event)"
                (dragleave)="onRxDragLeave()"
                (drop)="onRxDrop(i, $event)"
                (dragend)="onRxDragEnd()"
              >
                <!-- <h5 class="mb-2">Prescription {{ i + 1 }}</h5> -->
                <div class="d-flex justify-content-between align-items-center">
                  <h4 class="mb-0 d-flex align-items-center">
                    <i
                      class="pi pi-bars rx-drag-handle me-2"
                      style="cursor: move"
                      title="Drag to reorder Rx"
                    ></i>
                    <i class="pi pi-file-edit me-2"></i>Rx {{ i + 1 }}
                    <span
                      *ngIf="pres.is_from_history"
                      class="badge ms-3 px-2 py-1 fw-normal shadow-sm"
                      style="
                        background-color: #ecfdf5;
                        color: #065f46;
                        border: 1px solid #6ee7b7;
                        font-size: 0.75rem;
                        display: inline-flex;
                        align-items: center;
                        gap: 4px;
                      "
                      title="This prescription was imported from past history"
                    >
                      <i class="pi pi-history" style="font-size: 0.75rem"></i>
                      Imported from History
                    </span>
                    <span
                      *ngIf="isRxLinkedToTemplate(i)"
                      class="rx-linked-template-badge ms-3"
                      [title]="'This Rx is linked to template: ' + getRxLinkedTemplateName(i)"
                    >
                      <i class="pi pi-bookmark"></i>
                      <span>{{ getRxLinkedTemplateName(i) }}</span>
                      <button
                        type="button"
                        class="rx-unlink-template-btn"
                        (click)="unlinkTemplateFromRx(i, $event)"
                        title="Unlink template (save as new next time)"
                      >
                        <i class="pi pi-times"></i>
                      </button>
                    </span>
                  </h4>
                  <div class="template-actions">
                    <button
                      pButton
                      type="button"
                      [icon]="isRxLinkedToTemplate(i) ? 'pi pi-refresh' : 'pi pi-save'"
                      [label]="isRxLinkedToTemplate(i) ? 'Update Template' : 'Save as Template'"
                      class="p-button-success template-btn p-button-sm btn-sm me-2"
                      (click)="openSaveTemplateDialog($event, i)"
                    ></button>
                    <button
                      pButton
                      type="button"
                      icon="pi pi-folder-open"
                      label="Load Template"
                      class="p-button-info template-btn p-button-sm btn-sm me-2"
                      (click)="openLoadTemplateDialog(i)"
                    ></button>
                    <button
                      *ngIf="i === prescription.prescriptions.length - 1"
                      pButton
                      type="button"
                      icon="pi pi-plus-circle"
                      label="Add Prescription"
                      class="p-button-primary template-btn p-button-sm btn-sm"
                      data-validation-id="add-prescription-btn"
                      (click)="addPrescription()"
                      pTooltip="Add New Prescription"
                    ></button>
                  </div>
                </div>
                <hr />

                <div class="d-flex align-items-center gap-3 mb-4 mt-2">
                  <div
                    class="position-relative flex-grow-1"
                    style="max-width: 450px"
                  >
                    <div class="input-group input-group-sm">
                      <span
                        class="input-group-text fw-medium border-end-0"
                        style="
                          background-color: #e7fbe8;
                          color: #2e7d32;
                          border-color: #dee2e6;
                        "
                        >Rx Title <span class="text-danger ms-1">*</span></span
                      >
                      <input
                        type="text"
                        class="form-control border-start-0"
                        placeholder="Eg: Fever"
                        [attr.data-validation-id]="'rx-' + i + '-title'"
                        [(ngModel)]="pres.title"
                        required
                      />
                    </div>
                    @if (!pres.title) {
                      <div
                        class="position-absolute text-danger mt-1"
                        style="font-size: 11px; left: 0"
                      >
                        Title is required
                      </div>
                    }
                  </div>

                  <div
                    class="position-relative flex-grow-1"
                    style="max-width: 250px"
                  >
                    <div class="input-group input-group-sm">
                      <span
                        class="input-group-text fw-medium border-end-0"
                        style="
                          background-color: #e7fbe8;
                          color: #2e7d32;
                          border-color: #dee2e6;
                        "
                        >Duration <span class="text-danger ms-1">*</span></span
                      >
                      <input
                        type="text"
                        class="form-control border-start-0"
                        placeholder="Eg: 2 days"
                        [attr.data-validation-id]="'rx-' + i + '-duration'"
                        [(ngModel)]="pres.duration"
                        required
                      />
                    </div>
                    @if (!pres.duration) {
                      <div
                        class="position-absolute text-danger mt-1"
                        style="font-size: 11px; left: 0"
                      >
                        Duration is required
                      </div>
                    }
                  </div>

                  <div class="ms-auto d-flex align-items-center gap-2">
                    <button
                      class="btn rx-inline-action-btn rx-reset-row-btn d-flex align-items-center"
                      title="Reset this Rx"
                      (click)="clearRx(i, $event)"
                    >
                      <i class="pi pi-eraser me-1"></i> Reset Rx
                    </button>

                    <button
                      class="btn rx-inline-action-btn rx-repertory-btn d-flex align-items-center"
                      title="Open repertory for this Rx"
                      (click)="openRepertoryDialog(i)"
                    >
                      <i class="pi pi-book me-1"></i> Repertory
                    </button>

                    <button
                      class="btn rx-inline-action-btn rx-add-row-btn d-flex align-items-center"
                      (click)="addMedicineRow(i)"
                    >
                      <i class="pi pi-plus-circle me-1"></i> Add Row
                    </button>
                  </div>
                </div>

                <div class="table-responsive" style="overflow: visible">
                  <table class="table custom-table align-middle">
                    <thead>
                      <tr>
                        <th style="width: 35px"></th>
                        <th style="width: 70%">
                          Medicine <span class="text-danger">*</span>
                        </th>
                        <th style="width: 8%">
                          Dose <span class="text-danger">*</span>
                        </th>
                        <th style="width: 22%">
                          Schedule <span class="text-danger">*</span>
                        </th>
                        <th class="rx-row-actions-head"></th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        *ngFor="let med of pres.medicines; let j = index"
                        class="rx-draggable-row"
                        [class.rx-draggable-row-dragging]="
                          draggingMedRxIndex === i && draggingMedIndex === j
                        "
                        [class.rx-draggable-row-over]="
                          dragOverMedRxIndex === i && dragOverMedIndex === j
                        "
                        draggable="true"
                        (dragstart)="onMedDragStart(i, j, $event)"
                        (dragover)="onMedDragOver(i, j, $event)"
                        (dragleave)="onMedDragLeave()"
                        (drop)="onMedDrop(i, j, $event)"
                        (dragend)="onMedDragEnd()"
                      >
                        <td
                          style="
                            cursor: move;
                            text-align: center;
                            color: #94a3b8;
                          "
                        >
                          <i
                            class="pi pi-bars"
                            title="Drag to reorder medicine"
                          ></i>
                        </td>
                        <td style="position: relative">
                          <!-- <pre>{{med.medicineTags | json}}</pre> -->

                          <div
                            class="tags-box"
                            [attr.data-validation-id]="
                              'rx-' + i + '-medicine-' + j
                            "
                            style="width: 100%; display: block"
                          >
                            <span class="tag-chip" *ngFor="let tag of med.tags">
                              {{ tag.name
                              }}<span *ngIf="tag.code && tag.potency">
                                <ng-container
                                  *ngIf="
                                    getPotencyParts(tag.potency) as potencyParts
                                  "
                                >
                                  (
                                  <ng-container
                                    *ngIf="
                                      potencyParts.hasHighlight;
                                      else plainPotencyA
                                    "
                                  >
                                    <span class="rx-potency-key">{{
                                      potencyParts.prefix
                                    }}</span
                                    >{{ potencyParts.suffix }}
                                  </ng-container>
                                  <ng-template #plainPotencyA>{{
                                    potencyParts.prefix
                                  }}</ng-template>
                                  )
                                </ng-container>
                                <ng-container
                                  *ngIf="getCodeParts(tag.code) as codeParts"
                                >
                                  (
                                  <span
                                    [class.rx-potency-key]="
                                      codeParts.hasHighlight
                                    "
                                    >{{ codeParts.prefix
                                    }}{{ codeParts.suffix }}</span
                                  >
                                  )
                                </ng-container>
                              </span>
                              <span
                                class="remove-button"
                                (click)="removeMedicineTag(i, j, tag)"
                                >&times;</span
                              >
                            </span>

                            <p-autoComplete
                              [(ngModel)]="med.medicineInput"
                              [suggestions]="med.filteredMedicines"
                              (completeMethod)="
                                onMedicineInputChange(i, j, $event)
                              "
                              field="name"
                              placeholder="Type medicine"
                              [forceSelection]="false"
                              [showEmptyMessage]="false"
                              (onSelect)="addMedicineTag(i, j, $event.value)"
                              (keydown.enter)="onMedicineEnter($event, i, j)"
                              styleClass="w-100 transparent-autocomplete medicine-autocomplete"
                              [panelStyleClass]="'transparent-dropdown-panel'"
                              required
                            >
                              <!-- style="width: 100% !important; display: block !important; flex: 1 !important;" -->
                              <ng-template let-item pTemplate="item">
                                {{ item.name }} ({{ item.potency || "New" }})
                                ({{ item.code || "New" }})
                              </ng-template>
                            </p-autoComplete>
                          </div>
                          @if (!med.medicineTags?.length) {
                            <div class="form-text text-danger">
                              Medicine is required
                            </div>
                          }
                          <div
                            *ngIf="med.unresolvedMedicines?.length"
                            class="unresolved"
                          >
                            <b>Unresolved:</b>
                            {{ med.unresolvedMedicines.join(", ") }}
                          </div>
                          <div
                            *ngIf="med.resolvedMedicines?.length"
                            class="resolved-meds"
                          >
                            <b>Resolved:</b>
                            {{ med.resolvedMedicines.join(", ") }}
                          </div>
                        </td>

                        <td>
                          <!-- <input type="text" [(ngModel)]="med.drams" style="padding: 0px 10px;"
                              class="form-control form-control-sm" placeholder="Eg: 2 drams" required> -->
                          <!-- <pre>{{ med.drams | json }}</pre> -->

                          <div
                            [attr.data-validation-id]="'rx-' + i + '-dose-' + j"
                          >
                            <p-autoComplete
                              [(ngModel)]="med.drams"
                              [suggestions]="med.filteredDoses"
                              (completeMethod)="onDoseComplete(i, j, $event)"
                              optionLabel="dose"
                              optionValue="dose"
                              placeholder="Select a dose"
                              required
                            ></p-autoComplete>
                          </div>
                          @if (!med.drams) {
                            <div class="form-text text-danger">
                              Dose is required
                            </div>
                          }
                        </td>
                        <td>
                          <input
                            type="text"
                            [(ngModel)]="med.ballers"
                            style="padding: 0px 10px"
                            [attr.data-validation-id]="
                              'rx-' + i + '-schedule-' + j
                            "
                            class="form-control form-control-sm"
                            placeholder="Eg: 2-0-2"
                            required
                          />
                          @if (!med.ballers) {
                            <div class="form-text text-danger">
                              Schedule is required
                            </div>
                          }
                        </td>
                        <td class="rx-row-actions-cell">
                          @if (pres.medicines.length > 1) {
                            <div class="rx-row-actions">
                              <button
                                type="button"
                                class="rx-row-action-btn rx-row-action-btn--delete"
                                (click)="removeMedicineRow(i, j)"
                                title="Delete row"
                                aria-label="Delete row"
                              >
                                <i class="pi pi-trash"></i>
                              </button>
                            </div>
                          }
                        </td>

                        <!-- <div *ngIf="med.unresolvedMedicines?.length" class="unresolved">
                              Unresolved:
                              <span *ngFor="let u of med.unresolvedMedicines">
                                {{ u }}
                              </span>
                            </div> -->
                      </tr>
                    </tbody>
                  </table>
                </div>

                <div class="text-end mb-2 rx-prescription-actions">
                  <button
                    class="btn rx-delete-inline-btn rx-delete-btn"
                    title="Delete Prescription"
                    (click)="removePrescription(i)"
                    *ngIf="prescription.prescriptions.length > 1"
                  >
                    <i class="pi pi-trash me-1"></i>
                  </button>
                </div>
              </div>
              <!-- Save Template Dialog -->
              <p-dialog
                [(visible)]="showSaveTemplateDialog"
                [modal]="true"
                [draggable]="false"
                [resizable]="false"
                [closable]="true"
                [showHeader]="false"
                [style]="{ width: '460px' }"
                styleClass="premium-save-dialog"
              >
                <!-- Content body -->
                <div class="psd-body">
                  <!-- Teal icon circle -->
                  <div class="psd-icon" [class.psd-icon-update]="isUpdatingExistingTemplate()">
                    <i [class]="isUpdatingExistingTemplate() ? 'pi pi-refresh' : 'pi pi-save'"></i>
                  </div>

                  <!-- Heading -->
                  <h3 class="psd-heading">
                    {{ isUpdatingExistingTemplate() ? 'Update Template' : 'Save as Template' }}
                  </h3>
                  <p class="psd-subtext">
                    {{
                      isUpdatingExistingTemplate()
                        ? 'Save your changes back to the existing prescription template'
                        : 'Create a reusable prescription template'
                    }}
                  </p>

                  <!-- Form field -->
                  <div class="psd-field">
                    <label class="psd-label"
                      >Template Name <span>*</span></label
                    >
                    <div class="psd-input-wrap">
                      <i class="pi pi-bookmark psd-input-icon"></i>
                      <input
                        type="text"
                        class="psd-input"
                        placeholder="e.g. Fever Protocol, Joint Pain Rx…"
                        [(ngModel)]="templateName"
                        [ngModelOptions]="{ standalone: true }"
                        (keydown.enter)="templateName.trim() && saveTemplate()"
                        autofocus
                      />
                    </div>
                    <small class="psd-hint">
                      {{
                        isUpdatingExistingTemplate()
                          ? 'You can also rename the template here before updating'
                          : 'A descriptive name helps you find it later'
                      }}
                    </small>
                    <label
                      class="psd-as-new"
                      *ngIf="
                        activePrescriptionIndex !== null &&
                        isRxLinkedToTemplate(activePrescriptionIndex)
                      "
                    >
                      <input
                        type="checkbox"
                        [(ngModel)]="saveTemplateAsNew"
                        [ngModelOptions]="{ standalone: true }"
                      />
                      Save as a new template instead
                    </label>
                  </div>
                </div>

                <!-- Footer -->
                <ng-template pTemplate="footer">
                  <div class="psd-footer">
                    <button
                      class="psd-btn psd-btn-cancel"
                      (click)="showSaveTemplateDialog = false"
                    >
                      Cancel
                    </button>
                    <button
                      class="psd-btn psd-btn-save"
                      [disabled]="!templateName.trim() || templateSaving"
                      (click)="saveTemplate()"
                    >
                      <i [class]="templateSaving ? 'pi pi-spin pi-spinner' : 'pi pi-check'"></i>
                      {{ isUpdatingExistingTemplate() ? 'Update Template' : 'Save Template' }}
                    </button>
                  </div>
                </ng-template>
              </p-dialog>

              <!-- Load Template Dialog -->
              <p-dialog
                header="Load Template"
                [(visible)]="showLoadTemplateDialog"
                [modal]="true"
                [maximizable]="true"
                [style]="{ width: '80%', minHeight: '600px' }"
                [draggable]="false"
                [resizable]="false"
                (onHide)="cancelRenameTemplate()"
              >
                <div class="template-browser">
                  <div class="template-toolbar mb-3">
                    <div class="template-sort-group">
                      <button
                        type="button"
                        class="template-sort-btn"
                        [class.active]="templateSortMode === 'alpha'"
                        (click)="setTemplateSortMode('alpha')"
                      >
                        A-Z
                      </button>
                      <button
                        type="button"
                        class="template-sort-btn"
                        [class.active]="templateSortMode === 'recent'"
                        (click)="setTemplateSortMode('recent')"
                      >
                        Recent
                      </button>
                      <button
                        type="button"
                        class="template-sort-btn"
                        [class.active]="templateSortMode === 'most_used'"
                        (click)="setTemplateSortMode('most_used')"
                      >
                        Most Used
                      </button>
                    </div>
                    <div class="template-apply-group">
                      <button
                        type="button"
                        class="template-sort-btn"
                        [class.active]="templateApplyMode === 'replace'"
                        (click)="templateApplyMode = 'replace'"
                      >
                        Replace Current
                      </button>
                      <button
                        type="button"
                        class="template-sort-btn"
                        [class.active]="templateApplyMode === 'append'"
                        (click)="templateApplyMode = 'append'"
                      >
                        Append as New Rx
                      </button>
                    </div>
                  </div>

                  <div class="alphabet-filter mb-3">
                    <button
                      *ngFor="let letter of alphabets"
                      class="alphabet-btn"
                      [class.active]="selectedAlphabet === letter"
                      (click)="filterByAlphabet(letter)"
                    >
                      {{ letter }}
                    </button>
                    <button
                      type="button"
                      class="alphabet-btn clear-btn"
                      [disabled]="!selectedAlphabet"
                      (click)="clearTemplateLetterFilter()"
                    >
                      Clear
                    </button>
                  </div>

                  <div class="search-section mb-4">
                    <span class="p-input-icon-left w-100">
                      <i class="pi pi-search"></i>
                      <input
                        type="text"
                        pInputText
                        placeholder="Search templates..."
                        class="w-100"
                        [(ngModel)]="searchQuery"
                        (input)="searchTemplates()"
                      />
                    </span>
                    <button
                      type="button"
                      class="search-clear-btn"
                      *ngIf="searchQuery"
                      (click)="clearTemplateSearch()"
                    >
                      <i class="pi pi-times"></i>
                    </button>
                  </div>

                  <!-- Premium Skeleton Loaders when templates are loading -->
                  <div class="templates-list" *ngIf="templatesLoading">
                    <div
                      class="template-card p-3 border rounded mb-4 shadow-sm"
                      *ngFor="let i of [1, 2]"
                    >
                      <div
                        class="d-flex justify-content-between align-items-center mb-3"
                      >
                        <div class="w-50">
                          <!-- Template Name skeleton -->
                          <p-skeleton
                            width="60%"
                            height="1.5rem"
                            styleClass="mb-2"
                          ></p-skeleton>
                          <!-- Template Meta Chips skeletons -->
                          <div class="d-flex gap-2">
                            <p-skeleton
                              width="4rem"
                              height="1.2rem"
                            ></p-skeleton>
                            <p-skeleton
                              width="5rem"
                              height="1.2rem"
                            ></p-skeleton>
                            <p-skeleton
                              width="4rem"
                              height="1.2rem"
                            ></p-skeleton>
                          </div>
                        </div>
                        <!-- Template Actions skeleton -->
                        <div class="template-actions">
                          <p-skeleton width="2.1rem" height="2.1rem" borderRadius="10px"></p-skeleton>
                          <p-skeleton width="6.5rem" height="2.1rem" borderRadius="10px"></p-skeleton>
                          <p-skeleton width="4.5rem" height="2.1rem" borderRadius="10px"></p-skeleton>
                          <p-skeleton width="2.1rem" height="2.1rem" borderRadius="10px"></p-skeleton>
                          <p-skeleton width="2.1rem" height="2.1rem" borderRadius="10px"></p-skeleton>
                        </div>
                      </div>

                      <!-- Prescription Card skeleton inside template -->
                      <div class="prescription-card p-3 border rounded mb-3">
                        <div
                          class="d-flex justify-content-between align-items-center mb-2"
                        >
                          <p-skeleton width="5rem" height="1.2rem"></p-skeleton>
                          <p-skeleton width="4rem" height="1.2rem"></p-skeleton>
                        </div>
                        <p-skeleton
                          width="8rem"
                          height="1rem"
                          styleClass="mb-3"
                        ></p-skeleton>
                        <div class="table-responsive">
                          <table class="table table-sm table-bordered">
                            <thead style="background-color: #e7fbe8">
                              <tr>
                                <th style="width: 5%">#</th>
                                <th style="width: 55%">Medicine</th>
                                <th style="width: 20%">Dose</th>
                                <th style="width: 20%">Schedule</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr *ngFor="let row of [1, 2]">
                                <td>
                                  <p-skeleton
                                    width="100%"
                                    height="1rem"
                                  ></p-skeleton>
                                </td>
                                <td>
                                  <p-skeleton
                                    width="80%"
                                    height="1rem"
                                  ></p-skeleton>
                                </td>
                                <td>
                                  <p-skeleton
                                    width="60%"
                                    height="1rem"
                                  ></p-skeleton>
                                </td>
                                <td>
                                  <p-skeleton
                                    width="60%"
                                    height="1rem"
                                  ></p-skeleton>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- Actual Templates List -->
                  <div
                    class="templates-list"
                    *ngIf="!templatesLoading && filteredTemplates.length > 0"
                  >
                    <div
                      *ngFor="let template of filteredTemplates"
                      class="template-card p-3 border rounded mb-4 shadow-sm"
                    >
                      <!-- Template Header -->
                      <div class="template-card__head">
                        <div class="template-card__identity">
                          <div class="template-title-row">
                            <h5
                              class="fw-bold mb-1"
                              *ngIf="!isRenamingTemplate(template)"
                              (dblclick)="startRenameTemplate(template, $event)"
                              title="Double-click to rename"
                            >
                              <i class="pi pi-bookmark text-primary me-2"></i>
                              <span [innerHTML]="template.displayNameHtml"></span>
                            </h5>
                            <input
                              *ngIf="isRenamingTemplate(template)"
                              type="text"
                              class="template-rename-input"
                              [(ngModel)]="renamingTemplateName"
                              [ngModelOptions]="{ standalone: true }"
                              [disabled]="isTemplateRenameSaving(template)"
                              (click)="$event.stopPropagation()"
                              (keydown)="onTemplateRenameKeydown($event, template)"
                              (blur)="commitRenameTemplate(template, $event)"
                            />
                            <button
                              type="button"
                              class="template-rename-btn"
                              *ngIf="!isRenamingTemplate(template)"
                              (click)="startRenameTemplate(template, $event)"
                              pTooltip="Rename template"
                              tooltipPosition="top"
                            >
                              <i class="pi pi-pencil"></i>
                            </button>
                          </div>
                          <div class="template-meta-inline">
                            <span class="template-meta-chip">
                              <i class="pi pi-file me-1"></i
                              >{{ template.prescriptions.length }} Rx
                            </span>
                            <span class="template-meta-chip">
                              <i class="pi pi-hashtag me-1"></i
                              >{{ getTemplateMedicineCount(template) }}
                              Medicines
                            </span>
                            <span class="template-meta-chip">
                              <i class="pi pi-bolt me-1"></i
                              >{{ getTemplateUseCount(template) }} Uses
                            </span>
                            <span
                              class="template-meta-chip"
                              *ngIf="getTemplateLastUsed(template) as lastUsed"
                            >
                              <i class="pi pi-history me-1"></i>Last used
                              {{ lastUsed | date: "MMM d, hh:mm a" }}
                            </span>
                          </div>
                        </div>

                        <div class="template-actions">
                          <button
                            type="button"
                            class="tpl-icon-btn"
                            [class.is-on]="isTemplatePinned(template)"
                            (click)="toggleTemplatePin(template)"
                            [pTooltip]="
                              isTemplatePinned(template)
                                ? 'Unpin template'
                                : 'Pin template'
                            "
                            tooltipPosition="top"
                          >
                            <i
                              [class]="
                                isTemplatePinned(template)
                                  ? 'pi pi-star-fill'
                                  : 'pi pi-star'
                              "
                            ></i>
                          </button>
                          <span class="tpl-date">
                            <i class="pi pi-calendar"></i>
                            {{ template.created_at | date: "MMM d, yyyy" }}
                          </span>
                          <button
                            type="button"
                            class="tpl-use-btn"
                            (click)="confirmLoadTemplate($event, template)"
                          >
                            <i class="pi pi-file-import"></i>
                            Use
                          </button>
                          <button
                            type="button"
                            class="tpl-icon-btn"
                            (click)="editTemplate(template)"
                            pTooltip="Load to edit, then Update Template"
                            tooltipPosition="top"
                          >
                            <i class="pi pi-pencil"></i>
                          </button>
                          <button
                            type="button"
                            class="tpl-icon-btn tpl-icon-btn--danger"
                            (click)="confirmDeleteTemplate($event, template)"
                            pTooltip="Delete template"
                            tooltipPosition="top"
                          >
                            <i class="pi pi-trash"></i>
                          </button>
                        </div>
                      </div>

                      <!-- Prescription Cards -->
                      <div *ngIf="template.prescriptions?.length">
                        <div
                          *ngFor="
                            let pres of template.prescriptions;
                            let i = index
                          "
                          class="prescription-card p-3 border rounded mb-3"
                        >
                          <!-- Prescription Header -->
                          <div
                            class="d-flex justify-content-between align-items-center mb-2"
                          >
                            <h6 class="fw-bold text-success mb-0">
                              Rx {{ i + 1 }}
                            </h6>
                            <span
                              *ngIf="pres.duration"
                              class="prescription-duration"
                            >
                              <i class="pi pi-clock me-1"></i
                              >{{ pres.duration }}
                            </span>
                          </div>

                          <div
                            *ngIf="pres.title"
                            class="text-muted fst-italic mb-2"
                            [innerHTML]="pres.displayTitleHtml"
                          ></div>

                          <!-- Medicines Table -->
                          <div
                            *ngIf="pres.medicines?.length"
                            class="table-responsive"
                          >
                            <table
                              class="table table-sm table-bordered align-middle"
                            >
                              <thead style="background-color: #e7fbe8">
                                <tr>
                                  <th>#</th>
                                  <th>Medicine</th>
                                  <th>Dose</th>
                                  <th>Schedule</th>
                                </tr>
                              </thead>
                              <tbody>
                                <ng-container
                                  *ngFor="
                                    let med of pres.medicines;
                                    let j = index
                                  "
                                >
                                  <tr
                                    *ngIf="
                                      med.medicineTags?.length ||
                                      med.drams ||
                                      med.ballers
                                    "
                                  >
                                    <td>{{ j + 1 }}</td>
                                    <td>
                                      <span
                                        class="tag-chip gap-2 d-inline-flex flex-wrap"
                                        *ngFor="
                                          let tag of med.medicineTags;
                                          let last = last
                                        "
                                      >
                                        <span>
                                          <span
                                            [innerHTML]="tag.displayNameHtml"
                                          ></span>
                                          <span
                                            class="mx-1"
                                            *ngIf="tag.potency"
                                          >
                                            (
                                            <span
                                              [innerHTML]="
                                                tag.displayPotencyHtml
                                              "
                                            ></span>
                                            )
                                          </span>
                                          <span class="mx-1" *ngIf="tag.code">
                                            [
                                            <span
                                              [innerHTML]="tag.displayCodeHtml"
                                            ></span>
                                            ]
                                          </span>
                                          <span *ngIf="!last">, </span>
                                        </span>
                                      </span>
                                      <span
                                        *ngIf="!med.medicineTags?.length"
                                        class="text-muted"
                                      >
                                        No medicine specified
                                      </span>
                                    </td>
                                    <td>
                                      <span
                                        [innerHTML]="med.displayDramsHtml"
                                      ></span>
                                    </td>
                                    <td>
                                      <span
                                        [innerHTML]="med.displayBallersHtml"
                                      ></span>
                                    </td>
                                  </tr>
                                </ng-container>
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- Empty State -->
                  <div
                    *ngIf="!templatesLoading && filteredTemplates.length === 0"
                    class="empty-state"
                  >
                    <i class="pi pi-inbox empty-icon"></i>
                    <h5>No Templates Found</h5>
                    <p class="text-muted">
                      <span *ngIf="searchQuery"
                        >No templates match your search criteria.</span
                      >
                      <span *ngIf="selectedAlphabet && !searchQuery"
                        >No templates start with "{{ selectedAlphabet }}".</span
                      >
                      <span *ngIf="!searchQuery && !selectedAlphabet"
                        >Start by saving your first template!</span
                      >
                    </p>
                  </div>
                </div>
              </p-dialog>

              <!-- <hr>

                <div class="col-md-6">
                  <div class="row g-2">
                    <div class="col-md-10">
                      <label style="margin-top: 10px;">Diet</label>
                    </div>
                  </div>
                  <textarea name="diet" class="form-control" rows="2" [(ngModel)]="prescription.diet"></textarea>
                </div>

            
                <div class="col-md-6">
                
                  <div class="row g-2">
                    <div class="col-md-10">
                      <label style="margin-top: 10px;">Exercise</label>
                    </div>
                  </div>
                  <textarea name="exercise" class="form-control" rows="2"
                    [(ngModel)]="prescription.exercise"></textarea>
                </div> -->

              <!-- Bottom Section: Fees + Notes -->
              <div class="rx-bottom-section">
                <div class="pc-ncard rx-fees-card">
                  <div class="pc-ncard-header">
                    <span class="pc-ncard-icon billing"
                      ><i class="pi pi-receipt"></i
                    ></span>
                    <label>Billing</label>
                  </div>
                  <div class="rx-fees-row">
                    <div class="rx-fee-field">
                      <span class="rx-fee-label">Visit Fees</span>
                      <div class="rx-fee-input-wrap">
                        <span class="rx-fee-prefix" aria-hidden="true">₹</span>
                        <input
                          type="number"
                          class="rx-fee-input"
                          data-validation-id="visit-fees"
                          placeholder="0"
                          [(ngModel)]="prescription.visit_fees"
                          (ngModelChange)="
                            prescription.personal_dues = calculatePersonalDues(
                              filteredRecords,
                              prescription
                            )
                          "
                        />
                      </div>
                    </div>
                    <div class="rx-fee-field">
                      <span class="rx-fee-label">Personal Dues</span>
                      <div class="rx-fee-input-wrap">
                        <span class="rx-fee-prefix" aria-hidden="true">₹</span>
                        <input
                          type="number"
                          class="rx-fee-input rx-fee-dues"
                          placeholder="0"
                          [(ngModel)]="prescription.personal_dues"
                          [readonly]="true"
                        />
                      </div>
                    </div>
                  </div>
                </div>

                <div class="pc-ncard pc-ncard--notes rx-notes-card">
                  <div class="pc-ncard-header">
                    <span class="pc-ncard-icon notes"
                      ><i class="pi pi-clipboard"></i
                    ></span>
                    <label>Doctor Notes</label>
                  </div>
                  <textarea
                    name="notes"
                    rows="3"
                    class="rx-studio-textarea"
                    appAutoCapitalize
                    placeholder="Additional clinical notes…"
                    [(ngModel)]="prescription.notes"
                  ></textarea>
                </div>

                <div class="pc-ncard rx-instructions-card">
                  <div class="pc-ncard-header">
                    <span class="pc-ncard-icon instructions"
                      ><i class="pi pi-flag"></i
                    ></span>
                    <label>Special Instructions</label>
                  </div>
                  <textarea
                    name="special_instructions"
                    rows="3"
                    class="rx-studio-textarea"
                    appAutoCapitalize
                    placeholder="Patient-facing instructions…"
                    [(ngModel)]="prescription.special_instructions"
                  ></textarea>
                </div>
              </div>
            </div>
            <!-- /rx-patient-content -->
            </div>
            <!-- /rx-patient-page -->
            <!-- </p-scrollPanel> -->
          </p-tabPanel>

          <!-- Pre Consultation -->
          <p-tabPanel>
            <ng-template pTemplate="header">
              <span class="rx-tab-link">
                <i class="pi pi-clipboard"></i>
                <span>Pre Consultation</span>
              </span>
            </ng-template>
            <div class="pc-patient-tab">
              <!-- Vitals strip -->
              <div class="pc-vitals-section">
                <div class="pc-vsec-label">
                  <i class="pi pi-chart-line"></i> Vitals
                </div>
                <div class="pc-vitals-strip">
                  <div class="pc-vslot pc-vslot--bp">
                    <div class="pc-vslot-top">
                      <i class="pi pi-heart-fill"></i>
                      <span class="pc-vslot-label">BP</span>
                    </div>
                    <input
                      name="bp"
                      type="text"
                      placeholder="120/80"
                      [(ngModel)]="prescription.blood_pressure"
                      autocomplete="off"
                    />
                    <span class="pc-vslot-unit">mmHg</span>
                  </div>

                  <div class="pc-vslot pc-vslot--pulse">
                    <div class="pc-vslot-top">
                      <i class="pi pi-wave-pulse"></i>
                      <span class="pc-vslot-label">Pulse</span>
                    </div>
                    <input
                      name="pulseRate"
                      type="number"
                      placeholder="72"
                      [(ngModel)]="prescription.pulse_rate"
                      autocomplete="off"
                    />
                    <span class="pc-vslot-unit">bpm</span>
                  </div>

                  <div class="pc-vslot pc-vslot--temp">
                    <div class="pc-vslot-top">
                      <i class="pi pi-sun"></i>
                      <span class="pc-vslot-label">Temp</span>
                    </div>
                    <input
                      name="temperature"
                      type="number"
                      placeholder="98.6"
                      [(ngModel)]="prescription.temperature"
                      autocomplete="off"
                    />
                    <span class="pc-vslot-unit">°F</span>
                  </div>

                  <div class="pc-vslot pc-vslot--weight">
                    <div class="pc-vslot-top">
                      <i class="pi pi-circle-fill"></i>
                      <span class="pc-vslot-label">Weight</span>
                    </div>
                    <input
                      name="weight"
                      type="number"
                      placeholder="70"
                      [(ngModel)]="prescription.weight"
                      autocomplete="off"
                    />
                    <span class="pc-vslot-unit">kg</span>
                  </div>

                  <div class="pc-vslot pc-vslot--height">
                    <div class="pc-vslot-top">
                      <i class="pi pi-arrows-v"></i>
                      <span class="pc-vslot-label">Height</span>
                    </div>
                    <input
                      name="height"
                      type="number"
                      placeholder="170"
                      [(ngModel)]="prescription.height"
                      autocomplete="off"
                    />
                    <span class="pc-vslot-unit">cm</span>
                  </div>

                  <div class="pc-vslot pc-vslot--fbs">
                    <div class="pc-vslot-top">
                      <i class="pi pi-bolt"></i>
                      <span class="pc-vslot-label">FBS</span>
                    </div>
                    <input
                      name="fasting_blood_sugar"
                      type="number"
                      placeholder="90"
                      [(ngModel)]="prescription.fasting_blood_sugar"
                      autocomplete="off"
                    />
                    <span class="pc-vslot-unit">mg/dL</span>
                  </div>

                  <div class="pc-vslot pc-vslot--spo2">
                    <div class="pc-vslot-top">
                      <i class="pi pi-cloud"></i>
                      <span class="pc-vslot-label">SpO₂</span>
                    </div>
                    <input
                      name="blood_oxygen"
                      type="number"
                      placeholder="98"
                      [(ngModel)]="prescription.blood_oxygen"
                      autocomplete="off"
                    />
                    <span class="pc-vslot-unit">%</span>
                  </div>

                  <!-- Symptom toggles inline -->
                  <div class="pc-vsymptoms">
                    <label
                      class="pc-symptom-chip"
                      [class.active]="prescription.runny_nose"
                      for="rxRunnyNose"
                    >
                      <input
                        id="rxRunnyNose"
                        type="checkbox"
                        [(ngModel)]="prescription.runny_nose"
                      />
                      <i class="pi pi-inbox"></i> Runny Nose
                    </label>
                    <label
                      class="pc-symptom-chip"
                      [class.active]="prescription.cough"
                      for="rxCough"
                    >
                      <input
                        id="rxCough"
                        type="checkbox"
                        [(ngModel)]="prescription.cough"
                      />
                      <i class="pi pi-microphone"></i> Cough
                    </label>
                  </div>
                </div>
              </div>

              <!-- Blood Group + Medical History -->
              <div class="pc-notes-area">
                <!-- Blood Group card -->
                <div class="rx-blood-section">
                  <div class="pc-vsec-label" style="margin-bottom: 10px">
                    <i class="pi pi-heart-fill" style="color: #ef4444"></i>
                    Blood Group
                  </div>
                  <div class="blood-options text-center">
                    <label
                      class="blood-drop"
                      *ngFor="
                        let bg of [
                          'A+',
                          'A-',
                          'B+',
                          'B-',
                          'AB+',
                          'AB-',
                          'O+',
                          'O-',
                        ]
                      "
                    >
                      <input
                        type="radio"
                        name="bloodGroup"
                        [value]="bg"
                        [(ngModel)]="patient.blood_group"
                      />
                      <div class="drop-icon">
                        <svg
                          viewBox="0 0 64 64"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M32 2C32 2 12 26 12 40a20 20 0 0040 0C52 26 32 2 32 2z"
                          />
                        </svg>
                        <span>{{ bg }}</span>
                      </div>
                    </label>
                  </div>
                </div>

                <!-- Medical History grid (4 notes) -->
                <div class="rx-precon-history-grid">
                  <div class="pc-ncard pc-ncard--allergy">
                    <div class="pc-ncard-header">
                      <span class="pc-ncard-icon allergy"
                        ><i class="pi pi-exclamation-triangle"></i
                      ></span>
                      <label>Allergies</label>
                    </div>
                    <textarea
                      name="allergies"
                      rows="3"
                      appAutoCapitalize
                      [(ngModel)]="prescription.allergies"
                      placeholder="Known allergies and reactions…"
                    ></textarea>
                  </div>
                  <div class="pc-ncard">
                    <div class="pc-ncard-header">
                      <span class="pc-ncard-icon meds"
                        ><i class="pi pi-box"></i
                      ></span>
                      <label>Current Medications</label>
                    </div>
                    <textarea
                      name="current_medications"
                      rows="3"
                      appAutoCapitalize
                      [(ngModel)]="prescription.current_medications"
                      placeholder="Ongoing medications and doses…"
                    ></textarea>
                  </div>
                  <div class="pc-ncard">
                    <div class="pc-ncard-header">
                      <span class="pc-ncard-icon history"
                        ><i class="pi pi-clock"></i
                      ></span>
                      <label>Past &amp; Family History</label>
                    </div>
                    <textarea
                      name="personal_family_history"
                      rows="3"
                      appAutoCapitalize
                      [(ngModel)]="prescription.personal_family_history"
                      placeholder="Personal and family medical history…"
                    ></textarea>
                  </div>
                  <div class="pc-ncard">
                    <div class="pc-ncard-header">
                      <span class="pc-ncard-icon surgical"
                        ><i class="pi pi-wrench"></i
                      ></span>
                      <label>Surgical History</label>
                    </div>
                    <textarea
                      name="surgical_history"
                      rows="3"
                      appAutoCapitalize
                      [(ngModel)]="prescription.surgical_history"
                      placeholder="Past surgeries and procedures…"
                    ></textarea>
                  </div>
                </div>
              </div>
            </div>
            <p-confirmDialog [style]="{ width: '100%' }"></p-confirmDialog>
          </p-tabPanel>

          <p-tabPanel
            style="width: 100%; min-width: 100% !important"
          >
            <ng-template pTemplate="header">
              <span class="rx-tab-link">
                <i class="pi pi-file-pdf"></i>
                <span>Lab Reports</span>
              </span>
            </ng-template>
            <!--! PRESCRIPTION PDF -->
            <div id="prescription-pdf" class="prescription-container">
              <!-- HEADER -->
              <div class="header">
                <!-- <div class="logo-section"> -->
                <img src="{{ logo }}" alt="logo" />
                <!-- <div class="logo-placeholder">CLINIC<br>LOGO</div> -->
                <!-- </div> -->

                <div class="header-info">
                  <!-- <div class="clinic-name">Dr. Shailesh Sancheti</div>
                        <div class="clinic-name">Advanced Homeopathic Clinic</div> -->
                  <!-- <div class="doctor-name">Dr. Shailesh Sancheti</div>
                        <div class="credentials">BHMS, MD (Homeopathy)</div> -->
                  <div class="contact-info">
                    Sr. No. 2/14, Opp. Purandar (MHADA) Building, Near
                    Paneerwala, Maharshi Nagar<br />
                    Pune, Maharashtra – 411037 | Ph: 8070 7080 01/02/03 | Email:
                    drshaileshsancheti&#64;gmail.com
                  </div>
                </div>
              </div>

              <div class="sub-header">
                <div class="specialization">
                  SPECIALIZED IN THYROID, HAIR, SKIN & DIABETES
                </div>
                <div class="timing">
                  Time: Morning - 11 am to 2 pm | Evening - 6 pm to 8 pm
                </div>
              </div>

              <!-- PATIENT INFO -->
              <div class="patient-info">
                <div class="info-row">
                  <span class="info-label">Patient Name:</span>
                  <span class="info-value"
                    >{{ patient.first_name }} {{ patient.middle_name }}
                    {{ patient.last_name }}</span
                  >
                </div>

                <div class="info-row">
                  <span class="info-label">Date:</span>
                  <span class="info-value">{{ selectedDate }}</span>
                </div>

                <div class="info-row">
                  <span class="info-label">Age:</span>
                  <span class="info-value">{{ patient.age }}</span>
                </div>

                <div class="info-row">
                  <span class="info-label">Sex:</span>
                  <span class="info-value">{{ patient.gender }}</span>
                </div>
              </div>

              <!-- VITALS -->
              <div class="vitals-section">
                <div class="section-title">Vitals</div>
                <div class="vitals-grid">
                  <div class="vital-item">
                    <div class="vital-label">Blood Pressure</div>
                    <div class="vital-value">
                      {{ prescription.blood_pressure }} mmHg
                    </div>
                  </div>
                  <div class="vital-item">
                    <div class="vital-label">Pulse Rate</div>
                    <div class="vital-value">
                      {{ prescription.pulse_rate }} bpm
                    </div>
                  </div>
                  <div class="vital-item">
                    <div class="vital-label">Temperature</div>
                    <div class="vital-value">
                      {{ prescription.temperature }}°C
                    </div>
                  </div>
                  <div class="vital-item">
                    <div class="vital-label">Weight</div>
                    <div class="vital-value">{{ prescription.weight }} kg</div>
                  </div>
                  <div class="vital-item">
                    <div class="vital-label">Height</div>
                    <div class="vital-value">{{ prescription.height }} cm</div>
                  </div>
                  <div class="vital-item">
                    <div class="vital-label">Fasting Blood Sugar</div>
                    <div class="vital-value">
                      {{ prescription.fasting_blood_sugar }} mg/dL
                    </div>
                  </div>
                  <div class="vital-item">
                    <div class="vital-label">Blood Oxygen</div>
                    <div class="vital-value">
                      {{ prescription.blood_oxygen }}%
                    </div>
                  </div>
                </div>
              </div>

              <!-- COMPLAINTS -->
              <div class="complaints-section">
                <div class="section-title">Chief Complaints</div>
                <!-- <pre>{{complaintTags | json}}</pre> -->
                <ul>
                  <li *ngFor="let complaint of complaintTags">
                    <small>{{ formatTagDisplay(complaint) }}</small>
                  </li>
                </ul>
                <!-- <div class="complaints-text">
                        <div *ngFor="let complaint of complaintTags">{{ formatTagDisplay(complaint) }}</div>
                      </div> -->
              </div>

              <!-- PRESCRIPTIONS -->
              <div class="prescriptions-section">
                <div class="section-title">Prescriptions</div>

                <!-- <pre>{{}}</pre> -->

                <div
                  class="prescription-item"
                  *ngFor="let p of prescription.prescriptions"
                >
                  <div class="prescription-title">
                    <!-- <pre>{{p | json}}</pre> -->
                    For {{ p.title }} – {{ p.duration }}
                  </div>

                  <ul class="medicine-list">
                    <li *ngFor="let m of p.medicines; let i = index">
                      {{ i + 1 }}. – {{ m.ballers }} {{ m.medicineInput }}
                    </li>
                  </ul>
                </div>
              </div>

              <!-- REPORTS -->
              <div class="reports-section" *ngIf="reportTags.length > 0">
                <div class="section-title">Suggested Reports</div>
                <ul>
                  <li *ngFor="let report of reportTags">
                    <small>{{ formatTagDisplay(report) }}</small>
                  </li>
                </ul>
              </div>

              <!-- FOOTER -->
              <div class="footer">
                <!-- <div><b>Follow-up:</b> 7th January 2026</div> -->
                <!-- <div>
                        <br>
                        _______________________<br>
                        Dr. Shailesh Sancheti
                      </div> -->
                <div class="signature-section">
                  <div class="signature-line"></div>
                  <div class="signature-name">Dr. Shailesh Sancheti</div>
                  <div class="signature-credentials">BHMS, MD (Homeopathy)</div>
                </div>
              </div>
            </div>

            <!-- 🔹 Generate Report Button -->

            <div class="text-end d-flex gap-3 mt-3">
              <button
                pButton
                type="button"
                label="Download Prescription"
                class="view-button-success"
                (click)="generatePrescriptionPDF()"
              ></button>
              <!-- <button pButton type="button" label="Download Prescription" class="view-button-success" (click)="printPrescription()">
                    </button> -->
              <!-- <button style="margin-bottom:16px;padding:8px 14px" (click)="downloadPrescriptionPDF()">
                      Download Prescription
                    </button> -->
              <button
                class="ai-tech-button"
                *ngIf="aiEnabled"
                (click)="generateAIPlan()"
                [disabled]="isLoading"
              >
                <span class="button-text">Generate Report</span>
              </button>
            </div>
            <!-- Sci-Fi AI Loading Overlay -->
            <div class="sf-overlay" *ngIf="isLoading" aria-hidden="true">
              <!-- animated background (hex + matrix lines) -->
              <div class="sf-bg">
                <div class="hex-layer"></div>
                <div class="matrix-layer"></div>
                <div class="particle-layer">
                  <span class="p"></span><span class="p"></span
                  ><span class="p"></span><span class="p"></span
                  ><span class="p"></span>
                </div>
              </div>

              <!-- central holo container -->
              <div class="sf-center">
                <!-- rotating neon rings -->
                <svg
                  class="rings"
                  viewBox="0 0 260 260"
                  width="260"
                  height="260"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <defs>
                    <radialGradient id="g1" cx="50%" cy="30%">
                      <stop
                        offset="0%"
                        stop-color="#00ffd6"
                        stop-opacity="0.9"
                      />
                      <stop
                        offset="60%"
                        stop-color="#00aaff"
                        stop-opacity="0.25"
                      />
                      <stop
                        offset="100%"
                        stop-color="#000000"
                        stop-opacity="0"
                      />
                    </radialGradient>
                  </defs>
                  <g transform="translate(130,130)">
                    <circle
                      class="ring ring-1"
                      r="110"
                      fill="none"
                      stroke="url(#g1)"
                      stroke-width="2"
                    />
                    <circle
                      class="ring ring-2"
                      r="82"
                      fill="none"
                      stroke="#0ff"
                      stroke-opacity="0.12"
                      stroke-width="3"
                    />
                    <circle
                      class="ring ring-3"
                      r="54"
                      fill="none"
                      stroke="#00aaff"
                      stroke-opacity="0.16"
                      stroke-width="2"
                    />
                  </g>
                </svg>

                <!-- inner console / holo card -->
                <div class="holo-card">
                  <div class="holo-title">AI SYSTEM • SYNTHE-SCAN</div>
                  <div class="holo-console">
                    <div class="line l1">Initializing neural mesh...</div>
                    <div class="line l2">
                      Scanning patient vitals • BP • Pulse • Temp
                    </div>
                    <div class="line l3">
                      Synthesizing treatment vectors (3/5)
                    </div>
                    <div class="line l4">
                      Applying homeopathic protocols • Optimizing...
                    </div>
                    <div class="line l5">
                      Finalizing Diet & Exercise plan • Ready
                    </div>
                  </div>

                  <div class="holo-footer">
                    <div class="pulse-dot"></div>
                    <div class="status">
                      AI Generating<span class="dots">...</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- 🔹 p-editor Preview -->
            <div class="mt-3" *ngIf="aiPlan">
              <p-editor
                [(ngModel)]="aiPlan"
                [style]="{ height: '400px' }"
              ></p-editor>
            </div>

            <!-- 🔹 Download / Translate Options -->
            <!-- <div class="d-flex gap-2 align-items-center mt-3" *ngIf="aiPlan">
                    <p-dropdown [(ngModel)]="selectedRegionalLanguage" [options]="languageOptions" optionLabel="label" placeholder="Select language" [style]="{width:'220px'}"></p-dropdown>
                    <button class="btn btn-primary" (click)="downloadPDF('english')">Download PDF (English)</button>
                    <button class="btn btn-success" (click)="downloadPDF(selectedRegionalLanguage)" [disabled]="!selectedRegionalLanguage || selectedRegionalLanguage === 'english'">Download PDF (Regional)</button>
                  </div> -->

            <!-- <div class="d-flex gap-2 align-items-center mt-3" *ngIf="aiPlan">
                    <p-dropdown [(ngModel)]="selectedRegionalLanguage" [options]="languageOptions" optionLabel="label" placeholder="Select language" [style]="{width:'220px'}"></p-dropdown>
                    <button class="btn btn-primary" (click)="downloadPDFOriginal()">Download PDF</button>
                    <button class="btn btn-success" (click)="downloadPDF(selectedRegionalLanguage)" [disabled]="!selectedRegionalLanguage || selectedRegionalLanguage === 'english'">Download PDF (Regional)</button>
                  </div> -->

            <div class="d-flex gap-2 align-items-center mt-3" *ngIf="aiPlan">
              <!-- Download English PDF (for doctor) -->
              <button class="btn btn-primary" (click)="downloadPDFOriginal()">
                <i class="pi pi-download"></i> Download PDF (English)
              </button>

              <!-- Language selector and regional download (for patient) -->
              <ng-container *ngIf="aiEnabled">
                <p-dropdown
                  [(ngModel)]="selectedRegionalLanguage"
                  [options]="languageOptions"
                  optionLabel="label"
                  placeholder="Select language for patient"
                  [style]="{ width: '220px' }"
                >
                </p-dropdown>

                <button
                  class="btn btn-success"
                  (click)="downloadPDFRegional()"
                  [disabled]="
                    !selectedRegionalLanguage ||
                    selectedRegionalLanguage.value === 'english'
                  "
                >
                  <i class="pi pi-download"></i> Download PDF (Patient Copy)
                </button>
              </ng-container>
            </div>

            <!-- 🔹 Hidden Printable Area -->
            <div id="pdfPreview" style="display: none">
              <div class="pdf-container" [innerHTML]="aiPlan"></div>
            </div>
          </p-tabPanel>

          <!-- Personal Details Tab -->
          <p-tabPanel
            style="width: 100%; min-width: 100% !important"
          >
            <ng-template pTemplate="header">
              <span class="rx-tab-link">
                <i class="pi pi-user"></i>
                <span>Personal Details</span>
              </span>
            </ng-template>
            <div class="pc-personal-grid">
              <!-- Contact card -->
              <section class="pc-info-card">
                <div class="pc-info-card-head">
                  <div class="pc-info-card-icon pci--blue">
                    <i class="pi pi-phone"></i>
                  </div>
                  <span>Contact Details</span>
                </div>
                <div class="pc-facts-grid">
                  <div class="pc-fact">
                    <div class="pc-fact-icon pfi--green">
                      <i class="pi pi-mobile"></i>
                    </div>
                    <div class="pc-fact-body">
                      <span class="pc-fact-label">Primary Contact</span>
                      <span
                        class="pc-fact-value"
                        [class.pc-fact-empty]="!patient.primary_contact"
                      >
                        {{ patient.primary_contact || "Not provided" }}
                      </span>
                    </div>
                  </div>
                  <div class="pc-fact">
                    <div class="pc-fact-icon pfi--teal">
                      <i class="pi pi-phone"></i>
                    </div>
                    <div class="pc-fact-body">
                      <span class="pc-fact-label">Secondary Contact</span>
                      <span
                        class="pc-fact-value"
                        [class.pc-fact-empty]="!patient.secondary_contact"
                      >
                        {{ patient.secondary_contact || "Not provided" }}
                      </span>
                    </div>
                  </div>
                  <div class="pc-fact">
                    <div class="pc-fact-icon pfi--purple">
                      <i class="pi pi-users"></i>
                    </div>
                    <div class="pc-fact-body">
                      <span class="pc-fact-label">Referred By</span>
                      <span
                        class="pc-fact-value"
                        [class.pc-fact-empty]="!patient.referred_by"
                      >
                        {{ patient.referred_by || "Not provided" }}
                      </span>
                    </div>
                  </div>
                  <div class="pc-fact">
                    <div class="pc-fact-icon pfi--amber">
                      <i class="pi pi-calendar-plus"></i>
                    </div>
                    <div class="pc-fact-body">
                      <span class="pc-fact-label">First Visit</span>
                      <span
                        class="pc-fact-value"
                        [class.pc-fact-empty]="!patient.first_visit"
                      >
                        {{ patient.first_visit || "Not provided" }}
                      </span>
                    </div>
                  </div>
                </div>
              </section>

              <!-- Address card -->
              <section class="pc-info-card">
                <div class="pc-info-card-head">
                  <div class="pc-info-card-icon pci--orange">
                    <i class="pi pi-map-marker"></i>
                  </div>
                  <span>Address</span>
                </div>

                <div
                  class="pc-addr-block"
                  *ngIf="patient.address; else noAddress"
                >
                  <i class="pi pi-home"></i>
                  <span>{{ patient.address }}</span>
                </div>
                <ng-template #noAddress>
                  <div class="pc-addr-empty">
                    <i class="pi pi-map-marker"></i> No address on file
                  </div>
                </ng-template>

                <div class="pc-location-row">
                  <div class="pc-loc-chip" *ngIf="patient.city">
                    <i class="pi pi-building"></i>
                    <div class="pc-loc-content">
                      <span class="pc-loc-label">City</span>
                      <span class="pc-loc-value">{{ patient.city }}</span>
                    </div>
                  </div>
                  <div class="pc-loc-chip" *ngIf="patient.state">
                    <i class="pi pi-map"></i>
                    <div class="pc-loc-content">
                      <span class="pc-loc-label">State</span>
                      <span class="pc-loc-value">{{ patient.state }}</span>
                    </div>
                  </div>
                  <div class="pc-loc-chip" *ngIf="patient.country">
                    <i class="pi pi-globe"></i>
                    <div class="pc-loc-content">
                      <span class="pc-loc-label">Country</span>
                      <span class="pc-loc-value">{{ patient.country }}</span>
                    </div>
                  </div>
                  <div class="pc-loc-chip" *ngIf="patient.pincode">
                    <i class="pi pi-hashtag"></i>
                    <div class="pc-loc-content">
                      <span class="pc-loc-label">PIN</span>
                      <span class="pc-loc-value">{{ patient.pincode }}</span>
                    </div>
                  </div>
                </div>
              </section>
            </div>
          </p-tabPanel>

          <!-- Reports & Documents Tab -->
          <p-tabPanel styleClass="rx-reports-tab-panel">
            <ng-template pTemplate="header">
              <span class="rx-tab-link">
                <i class="pi pi-folder"></i>
                <span>Reports &amp; Documents</span>
              </span>
            </ng-template>
            <ng-container *ngIf="isReportsTabActive()">
            <div class="rd-shell">
              <div class="rd-workspace">
                <aside class="rd-sidebar">
                  <div class="rd-panel rd-panel--upload">
                    <div class="rd-panel-head">
                      <div class="rd-panel-icon rd-panel-icon--blue">
                        <i class="pi pi-cloud-upload"></i>
                      </div>
                      <div>
                        <span class="rd-panel-title">Upload Files</span>
                        <span class="rd-panel-sub">Up to {{ reportUploadMaxMb }} MB</span>
                      </div>
                    </div>

                    <div class="pc-report-type-field">
                      <label>Report Type</label>
                      <p-dropdown
                        [options]="reportTypeOptions"
                        [(ngModel)]="pendingReportType"
                        optionLabel="label"
                        optionValue="value"
                        optionGroupLabel="label"
                        optionGroupChildren="items"
                        placeholder="Select report type"
                        [filter]="true"
                        filterPlaceholder="Search report type"
                        appendTo="body"
                        styleClass="pc-report-type-dropdown w-100"
                      ></p-dropdown>
                    </div>

                    <div
                      class="rd-dropzone"
                      [class.rd-dropzone--active]="docDropzoneActive"
                      (dragenter)="onDocDropzoneDragEnter($event)"
                      (dragover)="onDocDropzoneDragOver($event)"
                      (dragleave)="onDocDropzoneDragLeave($event)"
                      (drop)="onDocDropzoneDrop($event)"
                    >
                      <input
                        id="docUpload"
                        type="file"
                        class="pc-file-input"
                        multiple
                        accept="image/png,image/jpeg,image/jpg,application/pdf"
                        (change)="onFileSelect($event)"
                      />
                      <label for="docUpload" class="rd-dropzone-inner">
                        <i class="pi pi-upload"></i>
                        <span class="rd-dropzone-title">Drop or browse</span>
                      </label>
                    </div>

                    <div class="rd-pending" *ngIf="pendingFiles.length">
                      <div class="rd-pending-head">
                        <i class="pi pi-paperclip"></i>
                        {{ pendingFiles.length }} ready
                      </div>
                      <div class="rd-pending-list">
                        <div class="rd-pending-item" *ngFor="let f of pendingFiles">
                          <i
                            class="pi"
                            [ngClass]="
                              f.type.startsWith('image/')
                                ? 'pi-image'
                                : 'pi-file-pdf'
                            "
                          ></i>
                          <span>{{ f.name }}</span>
                        </div>
                      </div>
                      <button
                        class="pc-btn pc-btn--send w-100"
                        [disabled]="isUploadingReports"
                        (click)="onUploadSelectedFiles()"
                      >
                        <i
                          class="pi"
                          [ngClass]="
                            isUploadingReports
                              ? 'pi-spin pi-spinner'
                              : 'pi-arrow-up-right'
                          "
                        ></i>
                        {{ isUploadingReports ? "Uploading…" : "Upload" }}
                      </button>
                    </div>
                  </div>

                  <div class="rd-panel rd-panel--text">
                    <div class="rd-panel-head">
                      <div class="rd-panel-icon rd-panel-icon--violet">
                        <i class="pi pi-file-edit"></i>
                      </div>
                      <div>
                        <span class="rd-panel-title">Text Report</span>
                        <span class="rd-panel-sub">Manual entry</span>
                      </div>
                    </div>

                    <input
                      type="text"
                      class="pc-trc-input"
                      placeholder="Title (optional)"
                      appAutoCapitalize
                      [(ngModel)]="reportTextTitle"
                    />
                    <textarea
                      class="pc-trc-textarea pc-trc-textarea--large"
                      rows="8"
                      placeholder="Report content…"
                      appAutoCapitalize
                      [(ngModel)]="reportTextContent"
                    ></textarea>
                    <div
                      class="pc-trc-counter"
                      [class.pc-trc-counter--over]="isTextReportContentOverLimit()"
                    >
                      {{ getTextReportCounterLabel() }}
                    </div>
                    <button
                      class="pc-btn pc-btn--primary w-100"
                      [disabled]="
                        !reportTextContent.trim() ||
                        isSavingTextReport ||
                        isTextReportContentOverLimit()
                      "
                      (click)="saveTextReport()"
                    >
                      <i
                        class="pi"
                        [ngClass]="
                          isSavingTextReport ? 'pi-spin pi-spinner' : 'pi-save'
                        "
                      ></i>
                      {{ isSavingTextReport ? "Saving…" : "Save" }}
                    </button>
                  </div>
                </aside>

                <section class="rd-library">
                  <div class="rd-library-head">
                    <div class="rd-library-title-wrap">
                      <h6 class="rd-library-title">Documents</h6>
                      <span class="rd-library-count" *ngIf="reportsMeta.total">
                        {{ patientReportsLoadedCount }}/{{ reportsMeta.total }}
                      </span>
                      <span class="rd-library-count" *ngIf="!reportsMeta.total">
                        {{ patientReportsLoadedCount }}
                      </span>
                    </div>
                    <div class="rd-search-wrap">
                      <i class="pi pi-search"></i>
                      <input
                        type="search"
                        class="rd-search"
                        placeholder="Search…"
                        [ngModel]="reportsDocSearch"
                        (ngModelChange)="onReportsDocSearchChange($event)"
                      />
                    </div>
                  </div>

                  <div class="rd-filter-row">
                    <button
                      type="button"
                      class="rd-filter-chip"
                      *ngFor="let filter of visibleReportsDocFilters"
                      [class.rd-filter-chip--active]="
                        reportsDocFilter === filter.value
                      "
                      (click)="setReportsDocFilter(filter.value)"
                    >
                      <i class="pi" [ngClass]="filter.icon"></i>
                      {{ filter.label }}
                    </button>
                    <button
                      type="button"
                      class="rd-filter-chip rd-filter-chip--compare"
                      [class.rd-filter-chip--active]="imageCompareMode"
                      [disabled]="!imageCompareMode && !canEnterImageCompareMode()"
                      (click)="toggleImageCompareMode()"
                      [pTooltip]="
                        canEnterImageCompareMode()
                          ? 'Select before and after photos to compare'
                          : 'Upload at least two images to compare'
                      "
                      tooltipPosition="top"
                      appendTo="body"
                    >
                      <i class="pi pi-images"></i>
                      Compare
                    </button>
                  </div>

                  <div class="rd-compare-bar" *ngIf="imageCompareMode">
                    <div class="rd-compare-bar__copy">
                      <div class="rd-compare-targets">
                        <button
                          type="button"
                          class="rd-compare-target"
                          [class.rd-compare-target--active]="imageCompareTarget === 'before'"
                          (click)="setImageCompareTarget('before')"
                        >
                          Before
                          <em>{{ imageCompareBefore.length }}/{{ imageCompareMaxPerSide }}</em>
                        </button>
                        <button
                          type="button"
                          class="rd-compare-target"
                          [class.rd-compare-target--active]="imageCompareTarget === 'after'"
                          (click)="setImageCompareTarget('after')"
                        >
                          After
                          <em>{{ imageCompareAfter.length }}/{{ imageCompareMaxPerSide }}</em>
                        </button>
                      </div>
                      <span>
                        Tap photos to add them to
                        <strong>{{ imageCompareTarget === 'before' ? 'Before' : 'After' }}</strong>
                      </span>
                    </div>
                    <div class="rd-compare-bar__actions">
                      <button
                        type="button"
                        class="pc-btn pc-btn--ghost"
                        (click)="exitImageCompareMode()"
                      >
                        Cancel
                      </button>
                      <button
                        type="button"
                        class="pc-btn pc-btn--primary"
                        [disabled]="!canOpenImageCompare()"
                        (click)="openImageCompareDialog()"
                      >
                        <i class="pi pi-th-large"></i>
                        Open comparison
                      </button>
                    </div>
                  </div>

                  <div
                    class="rd-photo-history"
                    *ngIf="aiEnabled && (photoProgressHistoryLoading || photoProgressHistory.length)"
                    [class.rd-photo-history--open]="photoProgressHistoryOpen"
                  >
                    <header class="rd-photo-history__head">
                      <button
                        type="button"
                        class="rd-photo-history__toggle"
                        (click)="togglePhotoProgressHistory()"
                        [attr.aria-expanded]="photoProgressHistoryOpen"
                      >
                        <i
                          class="pi"
                          [ngClass]="photoProgressHistoryOpen ? 'pi-chevron-down' : 'pi-chevron-right'"
                          aria-hidden="true"
                        ></i>
                        <span class="rd-photo-history__toggle-copy">
                          <strong>Previous comparisons</strong>
                          <em *ngIf="!photoProgressHistoryLoading">
                            {{ photoProgressHistory.length }} saved
                          </em>
                          <em *ngIf="photoProgressHistoryLoading">Loading…</em>
                        </span>
                      </button>
                      <div class="rd-photo-history__actions" *ngIf="photoProgressHistoryOpen">
                        <button
                          type="button"
                          class="pc-btn pc-btn--ghost"
                          (click)="loadPhotoProgressHistory(); $event.stopPropagation()"
                          [disabled]="photoProgressHistoryLoading"
                          title="Refresh"
                        >
                          <i class="pi" [ngClass]="photoProgressHistoryLoading ? 'pi-spin pi-spinner' : 'pi-refresh'"></i>
                          Refresh
                        </button>
                      </div>
                    </header>

                    <div class="rd-photo-history__panel" *ngIf="photoProgressHistoryOpen">
                      <div class="rd-photo-history__loading" *ngIf="photoProgressHistoryLoading">
                        <i class="pi pi-spin pi-spinner"></i>
                        Loading past comparisons…
                      </div>

                      <div class="rd-photo-history__list" *ngIf="!photoProgressHistoryLoading && photoProgressHistory.length">
                        <button
                          type="button"
                          class="rd-photo-history__card"
                          *ngFor="let item of photoProgressHistory; trackBy: trackPhotoProgressHistory"
                          [attr.data-tone]="item._ui?.tone"
                          (click)="openSavedPhotoProgress(item)"
                        >
                          <div class="rd-photo-history__body">
                            <div class="rd-photo-history__topline">
                              <span
                                class="rd-photo-history__badge"
                                [attr.data-tone]="item._ui?.tone"
                              >
                                <i class="pi" [ngClass]="item._ui?.toneIcon"></i>
                                {{ item._ui?.levelLabel }}
                              </span>
                              <time *ngIf="item._ui?.savedOn as savedOn">{{ savedOn }}</time>
                            </div>
                            <strong class="rd-photo-history__title">{{ item._ui?.title }}</strong>
                            <div class="rd-photo-history__meta">
                              <span *ngIf="item._ui?.dateRange as range">{{ range }}</span>
                              <span>{{ item._ui?.counts }}</span>
                              <span
                                class="rd-photo-history__warn"
                                *ngIf="item._ui?.missing as missing"
                              >
                                {{ missing }} missing
                              </span>
                            </div>
                          </div>

                          <div
                            class="rd-photo-history__pairs"
                            *ngIf="item._ui?.pairs as pairs"
                            [attr.data-count]="pairs.length"
                          >
                            <div
                              class="rd-photo-history__pair"
                              *ngFor="let pair of pairs; trackBy: trackPhotoProgressPair"
                            >
                              <span class="rd-photo-history__pair-n" *ngIf="pairs.length > 1">{{ pair.index + 1 }}</span>
                              <div class="rd-photo-history__shot rd-photo-history__shot--before">
                                <img *ngIf="pair.before?.url" [src]="pair.before.url" alt="Before" />
                                <span *ngIf="!pair.before?.url" class="rd-photo-history__missing">?</span>
                                <em>Before</em>
                              </div>
                              <i class="pi pi-arrow-right rd-photo-history__arrow" aria-hidden="true"></i>
                              <div class="rd-photo-history__shot rd-photo-history__shot--after">
                                <img *ngIf="pair.after?.url" [src]="pair.after.url" alt="After" />
                                <span *ngIf="!pair.after?.url" class="rd-photo-history__missing">?</span>
                                <em>After</em>
                              </div>
                            </div>
                          </div>

                          <i class="pi pi-chevron-right rd-photo-history__chevron"></i>
                        </button>
                      </div>
                    </div>
                  </div>

                  <div class="rd-library-body">
                    <ng-container
                      *ngIf="uploadsByDate.length; else rdLibraryEmpty"
                    >
                      <ng-container
                        *ngIf="filteredUploadsByDate.length; else rdFilterEmpty"
                      >
                        <div
                          class="rd-date-group"
                          *ngFor="let group of filteredUploadsByDate"
                        >
                          <div class="rd-date-band">
                            <span class="rd-date-full">{{
                              group.date | date: "d MMM yyyy"
                            }}</span>
                            <span class="rd-date-count">{{
                              group.files.length
                            }}</span>
                          </div>

                          <div class="rd-doc-grid">
                            <article
                              class="rd-tile"
                              *ngFor="let file of group.files"
                              (click)="onReportTileClick(file)"
                              [class.rd-tile--text]="isTextReport(file)"
                              [class.rd-tile--insight]="hasReportInsight(file)"
                              [class.rd-tile--compare]="imageCompareMode"
                              [class.rd-tile--selected]="imageCompareMode && isImageCompareSelected(file)"
                              [class.rd-tile--before]="imageCompareMode && getImageCompareRole(file) === 'before'"
                              [class.rd-tile--after]="imageCompareMode && getImageCompareRole(file) === 'after'"
                              [class.rd-tile--disabled]="imageCompareMode && !isImageReport(file)"
                              [pTooltip]="getReportInsightTooltip(file)"
                              [tooltipDisabled]="imageCompareMode || !hasReportInsight(file)"
                              tooltipPosition="top"
                              appendTo="body"
                              tooltipStyleClass="pc-gallery-insight-tooltip"
                            >
                              <div
                                class="rd-tile-media"
                                [ngClass]="getReportDocKindClass(file)"
                              >
                                <div class="rd-tile-text" *ngIf="isTextReport(file); else rdTileMediaDefault">
                                  <span class="rd-tile-text__label">Text report</span>
                                  <p class="rd-tile-text__excerpt">{{ getTextReportExcerpt(file) }}</p>
                                  <span class="rd-tile-text__meta">
                                    <i class="pi pi-align-left"></i>
                                    {{ getTextReportLineCount(file) }} line{{ getTextReportLineCount(file) === 1 ? '' : 's' }}
                                  </span>
                                </div>
                                <ng-template #rdTileMediaDefault>
                                <img
                                  *ngIf="
                                    file.kind !== 'text' &&
                                    file.type?.startsWith('image/')
                                  "
                                  [src]="file.url"
                                  alt=""
                                />
                                <i
                                  *ngIf="
                                    file.kind === 'text' ||
                                    !file.type?.startsWith('image/')
                                  "
                                  class="pi"
                                  [ngClass]="getReportDocIcon(file)"
                                ></i>
                                </ng-template>

                                <div class="rd-tile-actions" *ngIf="!imageCompareMode">
                                  <button
                                    type="button"
                                    class="rd-action rd-action--retry"
                                    *ngIf="canRetryReportAnalysis(file)"
                                    (click)="retryReportAnalysis(file, $event)"
                                    title="Retry"
                                  >
                                    <i class="pi pi-refresh"></i>
                                  </button>
                                  <button
                                    type="button"
                                    class="rd-action rd-action--ai"
                                    *ngIf="aiEnabled && file.id"
                                    (click)="
                                      openReportAnalysis(file);
                                      $event.stopPropagation()
                                    "
                                    title="AI"
                                  >
                                    <i class="pi pi-sparkles"></i>
                                  </button>
                                  <button
                                    type="button"
                                    class="rd-action rd-action--delete"
                                    (click)="deleteUploadedReport(file, $event)"
                                    title="Delete"
                                  >
                                    <i class="pi pi-trash"></i>
                                  </button>
                                </div>

                                <span
                                  class="ra-status-chip rd-tile-status"
                                  [ngClass]="getReportStatusClass(file)"
                                  *ngIf="aiEnabled && file.id && !imageCompareMode"
                                >
                                  {{ getReportStatusLabel(file) }}
                                </span>

                                <span
                                  class="rd-compare-badge"
                                  *ngIf="imageCompareMode && getImageCompareRole(file) as role"
                                  [class.rd-compare-badge--before]="role === 'before'"
                                  [class.rd-compare-badge--after]="role === 'after'"
                                >
                                  {{ role === 'before' ? 'Before' : 'After' }}
                                </span>
                              </div>

                              <div class="rd-tile-foot">
                                <span class="rd-tile-name" [title]="file.name">{{
                                  file.name
                                }}</span>
                                <span
                                  class="rd-kind-chip"
                                  [ngClass]="getReportDocKindClass(file)"
                                >
                                  {{ getReportDocKindLabel(file) }}
                                </span>
                              </div>
                            </article>
                          </div>
                        </div>

                        <div class="rd-load-more" *ngIf="reportsMeta.hasMore">
                          <button
                            type="button"
                            class="pc-btn pc-btn--ghost"
                            (click)="loadMorePatientReports()"
                            [disabled]="reportsLoadingMore"
                          >
                            <i
                              class="pi"
                              [ngClass]="
                                reportsLoadingMore
                                  ? 'pi-spin pi-spinner'
                                  : 'pi-angle-down'
                              "
                            ></i>
                            {{
                              reportsLoadingMore ? "Loading…" : "Load more"
                            }}
                          </button>
                        </div>
                      </ng-container>

                      <ng-template #rdFilterEmpty>
                        <div class="rd-empty rd-empty--filter">
                          <i class="pi pi-filter-slash"></i>
                          <p>No matches</p>
                          <button
                            type="button"
                            class="pc-btn pc-btn--ghost"
                            (click)="
                              setReportsDocFilter('all'); reportsDocSearch = ''
                            "
                          >
                            Clear filters
                          </button>
                        </div>
                      </ng-template>
                    </ng-container>

                    <ng-template #rdLibraryEmpty>
                      <div class="rd-empty">
                        <i class="pi pi-inbox"></i>
                        <p>No documents yet</p>
                        <span>Upload or add a text report on the left.</span>
                      </div>
                    </ng-template>
                  </div>
                </section>
              </div>
            </div>
            </ng-container>
          </p-tabPanel>

          <!-- All History -->
          <p-tabPanel>
            <ng-template pTemplate="header">
              <span class="rx-tab-link">
                <i class="pi pi-history"></i>
                <span>All History</span>
              </span>
            </ng-template>
            <section class="pc-history-shell">
              <header class="pc-history-toolbar">
                <div>
                  <h6 class="pc-history-title">Patient Timeline</h6>
                  <span class="pc-history-count">
                    Showing <strong>{{ filteredRecords.length }}</strong> of
                    <strong>{{
                      historyTotalRecords || filteredRecords.length
                    }}</strong>
                    visits
                  </span>
                </div>
                <div style="display: flex; gap: 8px; align-items: center">
                  <button
                    type="button"
                    class="pc-btn pc-btn--primary"
                    (click)="loadSelectedHistoryRxs()"
                    [disabled]="historyLoading || selectedRxCount === 0"
                    title="Load Selected Rxs into Patient tab"
                  >
                    <i class="pi pi-arrow-left"></i>
                    Load
                    {{ selectedRxCount ? selectedRxCount + " " : "" }}Selected
                    Rx{{ selectedRxCount !== 1 ? "s" : "" }}
                  </button>
                  <button
                    class="pc-btn pc-btn--ghost"
                    (click)="refreshHistory()"
                    [disabled]="historyLoading"
                  >
                    <i class="pi pi-refresh"></i> Refresh
                  </button>
                </div>
              </header>

              <div class="pc-history-alert" *ngIf="historyError">
                <i class="pi pi-exclamation-circle"></i> {{ historyError }}
              </div>
              <div
                class="pc-history-loading"
                *ngIf="historyLoading && !filteredRecords.length"
              >
                <i class="pi pi-spin pi-spinner"></i> Loading visits…
              </div>

              <div class="rx-history-grid" *ngIf="filteredRecords.length">
                <aside class="rx-history-list">
                  <button
                    type="button"
                    *ngFor="
                      let record of filteredRecords;
                      let i = index;
                      trackBy: trackByHistoryRecord
                    "
                    class="rx-history-item"
                    [class.active]="selectedHistoryIndex === i"
                    (click)="selectHistoryRecord(i)"
                  >
                    <div class="rx-history-item-head position-relative">
                      <div class="rx-history-item-day">
                        {{ record.visit_date | date: "EEE" }}
                      </div>
                      <div class="rx-history-item-date">
                        {{ record.visit_date | date: "dd MMM yyyy" }}
                      </div>
                      <i
                        *ngIf="hasSelectedRx(record)"
                        class="pi pi-check-circle text-primary position-absolute"
                        style="
                          top: 0;
                          right: 0;
                          font-size: 1.1rem;
                          color: #0ea5e9 !important;
                        "
                        title="Contains selected Rx"
                      ></i>
                    </div>
                    <div class="rx-history-item-meta">
                      <span
                        *ngIf="record.appointment_type"
                        class="rx-history-item-chip"
                        [ngClass]="getAppointmentClass(record.appointment_type)"
                        >{{ record.appointment_type | titlecase }}</span
                      >
                      <span class="rx-history-item-chip neutral"
                        >Due:
                        {{
                          record.personal_dues ?? 0
                            | currency: "INR" : "symbol" : "1.0-0"
                        }}
                      </span>
                    </div>
                  </button>
                </aside>

                <article
                  class="rx-history-detail"
                  *ngIf="selectedHistoryRecord as record"
                >
                  <header class="pc-hd-head">
                    <div class="pc-hd-title-block">
                      <div class="pc-hd-kicker">
                        <i class="pi pi-calendar"></i> Visit Snapshot
                      </div>
                      <h6 class="pc-hd-date">
                        {{ record.visit_date | date: "fullDate" }}
                      </h6>
                      <span
                        *ngIf="record.appointment_type"
                        class="pc-hi-chip"
                        [ngClass]="getAppointmentClass(record.appointment_type)"
                      >
                        {{ record.appointment_type | titlecase }}
                      </span>
                    </div>
                    <div class="pc-hd-finance">
                      <div class="pc-finance-card fee">
                        <div class="lbl">Visit Fee</div>
                        <div class="val">
                          {{
                            record.visit_fees ?? 0
                              | currency: "INR" : "symbol" : "1.0-0"
                          }}
                        </div>
                      </div>
                      <div class="pc-finance-card cash">
                        <div class="lbl">Cash</div>
                        <div class="val">
                          {{
                            record.received_cash ?? 0
                              | currency: "INR" : "symbol" : "1.0-0"
                          }}
                        </div>
                      </div>
                      <div class="pc-finance-card online">
                        <div class="lbl">Online</div>
                        <div class="val">
                          {{
                            record.received_online ?? 0
                              | currency: "INR" : "symbol" : "1.0-0"
                          }}
                        </div>
                      </div>
                      <div class="pc-finance-card due">
                        <div class="lbl">Due</div>
                        <div class="val">
                          {{
                            record.personal_dues ?? 0
                              | currency: "INR" : "symbol" : "1.0-0"
                          }}
                        </div>
                      </div>
                    </div>
                  </header>

                  <section
                    class="pc-hd-section"
                    *ngIf="
                      record.blood_pressure ||
                      record.pulse_rate ||
                      record.temperature ||
                      record.weight ||
                      record.height ||
                      record.fasting_blood_sugar ||
                      record.blood_oxygen
                    "
                  >
                    <div class="pc-hd-section-title">
                      <i class="pi pi-heart-fill"></i> Vitals
                    </div>
                    <div class="pc-hd-vitals">
                      <div *ngIf="record.blood_pressure">
                        <span class="k">BP</span
                        ><span class="v">{{ record.blood_pressure }}</span
                        ><span class="u">mmHg</span>
                      </div>
                      <div *ngIf="record.pulse_rate">
                        <span class="k">Pulse</span
                        ><span class="v">{{ record.pulse_rate }}</span
                        ><span class="u">bpm</span>
                      </div>
                      <div *ngIf="record.temperature">
                        <span class="k">Temp</span
                        ><span class="v">{{ record.temperature }}</span
                        ><span class="u">°F</span>
                      </div>
                      <div *ngIf="record.weight">
                        <span class="k">Wt</span
                        ><span class="v">{{ record.weight }}</span
                        ><span class="u">kg</span>
                      </div>
                      <div *ngIf="record.height">
                        <span class="k">Ht</span
                        ><span class="v">{{ record.height }}</span
                        ><span class="u">cm</span>
                      </div>
                      <div *ngIf="record.fasting_blood_sugar">
                        <span class="k">FBS</span
                        ><span class="v">{{ record.fasting_blood_sugar }}</span
                        ><span class="u">mg/dL</span>
                      </div>
                      <div *ngIf="record.blood_oxygen">
                        <span class="k">SpO₂</span
                        ><span class="v">{{ record.blood_oxygen }}</span
                        ><span class="u">%</span>
                      </div>
                    </div>
                  </section>

                  <section class="pc-hd-section">
                    <div class="pc-hd-section-title">
                      <i class="pi pi-briefcase"></i> Clinical Notes
                    </div>
                    <div class="row g-2">
                      <div
                        class="col-md-6"
                        *ngIf="record.chief_complaints?.length"
                      >
                        <div class="pc-hd-note-card accent-blue">
                          <div class="pc-hd-note-title">Chief Complaints</div>
                          <ul
                            class="pc-bullet-list"
                            *ngIf="parseToArray(record.chief_complaints)"
                          >
                            <li
                              *ngFor="
                                let c of parseToArray(record.chief_complaints)
                              "
                            >
                              {{ c | titlecase }}
                            </li>
                          </ul>
                          <p
                            style="white-space: pre-line; margin: 0"
                            *ngIf="!parseToArray(record.chief_complaints)"
                          >
                            {{ record.chief_complaints | titlecase }}
                          </p>
                        </div>
                      </div>
                      <div class="col-md-6" *ngIf="record.diagnosis?.length">
                        <div class="pc-hd-note-card accent-red">
                          <div class="pc-hd-note-title">Diagnosis</div>
                          <ul
                            class="pc-bullet-list"
                            *ngIf="parseToArray(record.diagnosis)"
                          >
                            <li
                              *ngFor="let d of parseToArray(record.diagnosis)"
                            >
                              {{ d | titlecase }}
                            </li>
                          </ul>
                          <p
                            style="white-space: pre-line; margin: 0"
                            *ngIf="!parseToArray(record.diagnosis)"
                          >
                            {{ record.diagnosis | titlecase }}
                          </p>
                        </div>
                      </div>
                      <div
                        class="col-md-6"
                        *ngIf="record.suggested_reports?.length"
                      >
                        <div class="pc-hd-note-card accent-purple">
                          <div class="pc-hd-note-title">Suggested Reports</div>
                          <ul class="pc-bullet-list">
                            <li *ngFor="let r of record.suggested_reports">
                              {{ r | titlecase }}
                            </li>
                          </ul>
                        </div>
                      </div>
                      <div class="col-md-6" *ngIf="record.allergies">
                        <div class="pc-hd-note-card accent-red">
                          <div class="pc-hd-note-title">Allergies</div>
                          <p style="white-space: pre-line; margin: 0">
                            {{ record.allergies }}
                          </p>
                        </div>
                      </div>
                      <div class="col-md-6" *ngIf="record.current_medications">
                        <div class="pc-hd-note-card accent-green">
                          <div class="pc-hd-note-title">
                            Current Medications
                          </div>
                          <p style="white-space: pre-line; margin: 0">
                            {{ record.current_medications }}
                          </p>
                        </div>
                      </div>
                      <div
                        class="col-md-6"
                        *ngIf="record.personal_family_history"
                      >
                        <div class="pc-hd-note-card accent-sky">
                          <div class="pc-hd-note-title">Family History</div>
                          <p style="white-space: pre-line; margin: 0">
                            {{ record.personal_family_history }}
                          </p>
                        </div>
                      </div>
                      <div class="col-md-6" *ngIf="record.surgical_history">
                        <div class="pc-hd-note-card accent-teal">
                          <div class="pc-hd-note-title">Surgical History</div>
                          <p style="white-space: pre-line; margin: 0">
                            {{ record.surgical_history }}
                          </p>
                        </div>
                      </div>
                      <div class="col-md-6" *ngIf="record.notes">
                        <div class="pc-hd-note-card accent-amber">
                          <div class="pc-hd-note-title">Notes</div>
                          <p style="white-space: pre-line; margin: 0">
                            {{ record.notes }}
                          </p>
                        </div>
                      </div>
                      <div class="col-md-6" *ngIf="record.special_instructions">
                        <div class="pc-hd-note-card accent-indigo">
                          <div class="pc-hd-note-title">
                            Special Instructions
                          </div>
                          <p style="white-space: pre-line; margin: 0">
                            {{ record.special_instructions }}
                          </p>
                        </div>
                      </div>
                    </div>
                  </section>

                  <section
                    *ngIf="record.prescriptions?.length"
                    class="rx-history-section"
                  >
                    <div class="rx-history-section-title">
                      <i class="pi pi-file-edit"></i>
                      Prescription Breakdown
                    </div>
                    <div
                      *ngFor="
                        let prescription of record.prescriptions;
                        let j = index
                      "
                      class="rx-history-prescription-card"
                    >
                      <div class="rx-history-rx-head">
                        <div class="d-flex align-items-center gap-2">
                          <input
                            type="checkbox"
                            class="modern-checkbox"
                            [(ngModel)]="prescription.selected"
                          />
                          <h6 class="fw-bold text-success mb-1">
                            Rx {{ j + 1 }}
                          </h6>
                          <div
                            *ngIf="prescription.title"
                            class="rx-history-rx-title"
                          >
                            {{ prescription.title }}
                          </div>
                        </div>
                        <div class="d-flex align-items-center gap-2">
                          <span
                            *ngIf="prescription.duration"
                            class="badge rounded-pill bg-light-green text-dark"
                          >
                            {{ prescription.duration }}
                          </span>
                          <button
                            type="button"
                            class="btn btn-sm rx-history-load-btn"
                            (click)="
                              loadHistoryPrescription(record, prescription)
                            "
                            title="Load into Patient tab"
                          >
                            <i class="pi pi-arrow-left me-1"></i>
                            Load
                          </button>
                        </div>
                      </div>

                      <div
                        *ngIf="prescription.medicines?.length"
                        class="table-responsive"
                      >
                        <table
                          class="table table-sm table-bordered align-middle rx-history-rx-table"
                        >
                          <thead>
                            <tr>
                              <th>#</th>
                              <th>Medicine</th>
                              <th>Dose</th>
                              <th>Schedule</th>
                            </tr>
                          </thead>
                          <tbody>
                            <ng-container
                              *ngFor="
                                let med of prescription.medicines;
                                let k = index
                              "
                            >
                              <tr
                                *ngIf="
                                  med.tags?.length || med.drams || med.ballers
                                "
                              >
                                <td>{{ k + 1 }}</td>
                                <td>
                                  <span
                                    class="tag-chip gap-3 ml-1"
                                    *ngFor="let tag of med.tags"
                                  >
                                    <span class="ml-1">
                                      {{ tag.name }} (
                                      <ng-container
                                        *ngIf="
                                          getCodeParts(tag.code) as codeParts
                                        "
                                      >
                                        <span
                                          [class.rx-potency-key]="
                                            codeParts.hasHighlight
                                          "
                                          >{{ codeParts.prefix
                                          }}{{ codeParts.suffix }}</span
                                        >
                                      </ng-container>
                                      -
                                      <ng-container
                                        *ngIf="
                                          getPotencyParts(
                                            tag.potency
                                          ) as potencyParts
                                        "
                                      >
                                        <ng-container
                                          *ngIf="
                                            potencyParts.hasHighlight;
                                            else plainPotencyC
                                          "
                                        >
                                          <span class="rx-potency-key">{{
                                            potencyParts.prefix
                                          }}</span
                                          >{{ potencyParts.suffix }}
                                        </ng-container>
                                        <ng-template #plainPotencyC>{{
                                          potencyParts.prefix
                                        }}</ng-template>
                                      </ng-container>
                                      )
                                    </span>
                                  </span>
                                </td>
                                <td>{{ med.drams }}</td>
                                <td>{{ med.ballers }}</td>
                              </tr>
                            </ng-container>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </section>
                </article>
              </div>

              <div
                class="pc-history-empty"
                *ngIf="!filteredRecords.length && !historyLoading"
              >
                <i class="pi pi-info-circle"></i>
                <p>No history found for this patient.</p>
              </div>

              <footer class="pc-history-footer" *ngIf="historyHasMore">
                <button
                  class="pc-btn pc-btn--ghost"
                  (click)="loadMoreHistory()"
                  [disabled]="historyLoadingMore"
                >
                  <i
                    class="pi"
                    [ngClass]="
                      historyLoadingMore
                        ? 'pi-spin pi-spinner'
                        : 'pi-angle-down'
                    "
                  ></i>
                  {{ historyLoadingMore ? "Loading…" : "Load more history" }}
                </button>
              </footer>
            </section>
          </p-tabPanel>
        </p-tabView>

        <ng-container *ngIf="validationIssues as issues">
          <!-- 🌟 Fixed footer buttons -->
          <div class="footer-buttons">
            <div class="rx-recall-indicator" *ngIf="recalledFromPharmacy">
              <i class="pi pi-refresh me-1"></i>
              Recalled from Pharmacy: you are editing the returned case.
            </div>

            <div class="rx-footer-dock">
              <div
                class="rx-draft-status-chip rx-draft-status-inline"
                *ngIf="patient?.patient_id"
                [ngClass]="'state-' + draftSaveState"
              >
                <i [class]="draftStatusIcon"></i>
                <span>{{ draftSaveLabel }}</span>
              </div>

              <div class="rx-footer-dock__actions">
                <button
                  type="button"
                  class="btn rx-action-btn rx-pharmacy-btn"
                  (click)="addPrescriptions('pharmacy')"
                  [disabled]="!isCaseValid() || isPrescriptionEmpty()"
                >
                  <i class="pi pi-send"></i>
                  Move to Pharmacy
                </button>

                <button
                  type="button"
                  class="btn rx-action-btn rx-case-btn"
                  (click)="addPrescriptions('case', $event)"
                  [disabled]="!isCaseValid()"
                >
                  <i class="pi pi-bookmark"></i>
                  Save Case
                </button>

                <button
                  type="button"
                  class="btn rx-action-btn rx-schedule-btn"
                  (click)="toggleSchedulePicker()"
                  [disabled]="!isCaseValid() || isPrescriptionEmpty()"
                >
                  <i class="pi pi-calendar-plus"></i>
                  Schedule Later
                </button>

                <ng-container *ngIf="showSchedulePicker">
                  <input
                    type="date"
                    class="form-control rx-schedule-date"
                    data-validation-id="schedule-date"
                    [(ngModel)]="scheduledDate"
                    [min]="minDate"
                  />

                  <button
                    *ngIf="scheduledDate"
                    type="button"
                    class="btn rx-action-btn rx-confirm-btn"
                    (click)="confirmSchedule()"
                  >
                    <i class="pi pi-check"></i>
                    Confirm
                  </button>

                  <button
                    *ngIf="scheduledDate"
                    type="button"
                    class="btn rx-action-btn rx-cancel-btn"
                    (click)="cancelSchedule()"
                  >
                    <i class="pi pi-times"></i>
                    Cancel
                  </button>
                </ng-container>

                <button
                  *ngIf="canRecallFromPharmacy()"
                  type="button"
                  class="btn rx-action-btn rx-recall-btn"
                  (click)="recallFromPharmacy($event)"
                >
                  <i class="pi pi-refresh"></i>
                  Recall Rx
                </button>

                <button
                  type="button"
                  class="btn rx-action-btn rx-draft-clear-btn"
                  (click)="clearCurrentDraft($event)"
                  [disabled]="!patient?.patient_id"
                >
                  <i class="pi pi-trash"></i>
                  Clear Draft
                </button>
              </div>

              <div class="rx-footer-dock__tools">
                <app-hotkey-help [inline]="true" />
              </div>
            </div>
          </div>

          <!-- <div class="rx-validation-float" *ngIf="issues.length > 0">
            <div class="rx-validation-bar">
              <div class="rx-validation-title">
                <i class="pi pi-exclamation-triangle me-1"></i>
                Complete these before saving:
              </div>
              <div class="rx-validation-items">
                <span class="rx-validation-item" *ngFor="let issue of issues">
                  {{ issue }}
                </span>
              </div>
            </div>
          </div> -->
        </ng-container>
      </div>
    </div>
  </div>

  <aside class="rx-fab-dock rx-fab-dock--left" *ngIf="!isPatientVisible" aria-label="Queue">
    <button
      pButton
      type="button"
      icon="pi pi-users"
      class="rx-fab-btn rx-fab-btn--queue"
      data-validation-id="patient-selection-fab"
      (click)="openQueueSidebar()"
      pTooltip="Open Queue"
      tooltipPosition="right"
      aria-label="Queue"
    ></button>
  </aside>

  <aside class="rx-fab-dock rx-fab-dock--right" aria-label="Quick actions">
    <button
      pButton
      type="button"
      [icon]="distanceView ? 'pi pi-eye' : 'pi pi-eye-slash'"
      class="rx-fab-btn rx-fab-btn--distance"
      [class.rx-fab-btn--active]="distanceView"
      (click)="toggleDistanceView()"
      [pTooltip]="distanceView ? 'Distance View: ON' : 'Distance View: OFF'"
      tooltipPosition="left"
      aria-label="Toggle distance view"
    ></button>

    <button
      pButton
      type="button"
      icon="pi pi-book"
      class="rx-fab-btn rx-fab-btn--repertory"
      (click)="openRepertoryDialog()"
      [disabled]="!prescription?.prescriptions?.length"
      pTooltip="Repertory"
      tooltipPosition="left"
      aria-label="Repertory"
    ></button>

    <button
      pButton
      type="button"
      icon="pi pi-search"
      class="rx-fab-btn rx-fab-btn--search"
      (click)="openMedicineSearchDialog()"
      [disabled]="true"
      pTooltip="Medicine Search"
      tooltipPosition="left"
      aria-label="Medicine Search"
    ></button>

    <button
      pButton
      type="button"
      icon="pi pi-bolt"
      class="rx-fab-btn rx-fab-btn--quick"
      [class.rx-fab-btn--active]="sidebarOpen"
      (click)="toggleSidebar()"
      pTooltip="Quick Prescription"
      tooltipPosition="left"
      aria-label="Quick Prescription"
    ></button>

    <button
      pButton
      type="button"
      icon="pi pi-comments"
      class="rx-fab-btn rx-fab-btn--notes"
      (click)="openDoctorNotesDialog()"
      [disabled]="!patient?.patient_id"
      pTooltip="Doctor Notes"
      tooltipPosition="left"
      aria-label="Doctor Notes"
    ></button>

    <button
      pButton
      type="button"
      icon="pi pi-heart"
      class="rx-fab-btn rx-fab-btn--anatomy"
      (click)="openAnatomyLink()"
      pTooltip="Anatomy"
      tooltipPosition="left"
      aria-label="Open Anatomy"
    ></button>
  </aside>
</div>

<p-confirmPopup key="templatePopup"></p-confirmPopup>
<p-confirmPopup key="clearRxPopup" styleClass="tpl-confirm-popup">
  <ng-template pTemplate="content">
    <div class="tpl-confirm">
      <div class="tpl-confirm__icon tpl-confirm__icon--danger" aria-hidden="true">
        <i class="pi pi-eraser"></i>
      </div>
      <div class="tpl-confirm__copy">
        <strong class="tpl-confirm__title">Clear Rx {{ pendingClearRxNumber }}?</strong>
        <p class="tpl-confirm__text">
          Title, duration, medicines, and the linked template will be removed. The prescription slot stays.
        </p>
      </div>
    </div>
  </ng-template>
</p-confirmPopup>
<p-confirmPopup key="loadTemplatePopup" styleClass="tpl-confirm-popup tpl-confirm-popup--load">
  <ng-template pTemplate="content">
    <div class="tpl-confirm">
      <div class="tpl-confirm__icon" aria-hidden="true">
        <i class="pi pi-file-import"></i>
      </div>
      <div class="tpl-confirm__copy">
        <strong class="tpl-confirm__title">
          {{ templateApplyMode === 'append' ? 'Add as a new Rx?' : 'Replace this Rx?' }}
        </strong>
        <p class="tpl-confirm__text" *ngIf="templateApplyMode === 'append'">
          “{{ pendingTemplateConfirm?.name || 'This template' }}” will be added as a new prescription. Your current Rx stays as it is.
        </p>
        <p class="tpl-confirm__text" *ngIf="templateApplyMode !== 'append'">
          The Rx you are editing will be replaced with “{{ pendingTemplateConfirm?.name || 'this template' }}”.
        </p>
        <div class="tpl-confirm__flow">
          <span
            class="tpl-confirm__chip"
            [class.tpl-confirm__chip--append]="templateApplyMode === 'append'"
          >
            {{ templateApplyMode === 'append' ? 'Append as new Rx' : 'Replace current' }}
          </span>
        </div>
      </div>
    </div>
  </ng-template>
</p-confirmPopup>
<p-confirmPopup key="deleteTemplatePopup" styleClass="tpl-confirm-popup tpl-confirm-popup--delete">
  <ng-template pTemplate="content">
    <div class="tpl-confirm">
      <div class="tpl-confirm__icon tpl-confirm__icon--danger" aria-hidden="true">
        <i class="pi pi-trash"></i>
      </div>
      <div class="tpl-confirm__copy">
        <strong class="tpl-confirm__title">Delete this template?</strong>
        <p class="tpl-confirm__text">
          “{{ pendingTemplateConfirm?.name || 'This template' }}” will be removed. This cannot be undone.
        </p>
      </div>
    </div>
  </ng-template>
</p-confirmPopup>
<p-confirmPopup key="recallPharmacyPopup" styleClass="recall-confirm-popup">
  <ng-template pTemplate="content">
    <div class="recall-confirm">
      <div class="recall-confirm__icon" aria-hidden="true">
        <i class="pi pi-replay"></i>
      </div>
      <div class="recall-confirm__copy">
        <strong class="recall-confirm__title">Recall this prescription?</strong>
        <p class="recall-confirm__text">
          Pull this case back from Pharmacy so you can edit the Rx. It will return to your queue.
        </p>
        <div class="recall-confirm__flow">
          <span class="recall-confirm__chip recall-confirm__chip--from">Pharmacy</span>
          <i class="pi pi-arrow-right" aria-hidden="true"></i>
          <span class="recall-confirm__chip recall-confirm__chip--to">Your queue</span>
        </div>
      </div>
    </div>
  </ng-template>
</p-confirmPopup>

<!-- QUICK PRESCRIPTION SIDEBAR -->
<div
  class="qp-backdrop"
  [class.qp-backdrop--visible]="sidebarOpen"
  (click)="closeQuickSidebar()"
  role="dialog"
  aria-modal="true"
  aria-labelledby="qp-panel-title"
>
  <aside
    class="qp-panel"
    data-hotkey="patient-search"
    (click)="$event.stopPropagation()"
  >
    <header class="qp-panel__header">
      <div class="qp-panel__title-wrap">
        <span class="qp-panel__icon"><i class="pi pi-bolt"></i></span>
        <div>
          <h2 id="qp-panel-title" class="qp-panel__title">Quick Prescription</h2>
          <p class="qp-panel__subtitle">Paste shorthand text — medicines resolve automatically</p>
        </div>
      </div>
      <button
        type="button"
        class="qp-panel__close"
        (click)="closeQuickSidebar()"
        aria-label="Close quick prescription"
      >
        <i class="pi pi-times"></i>
      </button>
    </header>

    <div class="qp-panel__guide">
      <div class="qp-guide__label">
        <i class="pi pi-info-circle"></i>
        <span>How it works</span>
      </div>
      <ul class="qp-guide__list">
        <li><strong>One line</strong> = one medicine row</li>
        <li><strong>;</strong> starts a new Rx block</li>
        <li><strong>+</strong> combines medicines on the same row</li>
        <li><strong>-</strong> or <strong>=</strong> separates medicines from dosing</li>
        <li><strong>|</strong> separates dose (left) from schedule (right)</li>
      </ul>
      <div class="qp-guide__example">
        <span class="qp-guide__example-label">Examples</span>
        <code>nux30 + lyc200 - 1 dram | bd 1w</code>
        <!-- <code class="qp-guide__example-alt">sulph30 - od 2w</code> -->
      </div>
    </div>

    <div class="qp-panel__body">
      <label class="qp-field__label" for="qp-textarea">Prescription text</label>
      <textarea
        id="qp-textarea"
        class="qp-field__textarea"
        [(ngModel)]="quickText"
        (keydown)="onQuickTextKeydown($event)"
        placeholder="Thuja 200 + lachesis 10 - 15ml | 15-0-15"
        spellcheck="false"
        rows="14"
      ></textarea>
      <div class="qp-field__meta">
        <span class="qp-field__lines">
          {{ quickTextLineCount }} line{{ quickTextLineCount === 1 ? '' : 's' }}
        </span>
        <span class="qp-field__chars" *ngIf="quickText.length">
          {{ quickText.length }} chars
        </span>
      </div>
    </div>

    <footer class="qp-panel__footer">
      <div class="qp-shortcuts">
        <kbd>Enter</kbd><span>add</span>
        <span class="qp-shortcuts__sep">·</span>
        <kbd>Shift</kbd><span>+</span><kbd>Enter</kbd><span>new line</span>
        <span class="qp-shortcuts__sep">·</span>
        <kbd>Esc</kbd><span>close</span>
      </div>
      <div class="qp-panel__actions">
        <button
          type="button"
          class="qp-btn qp-btn--ghost"
          (click)="clearQuickText()"
          [disabled]="!quickText.trim()"
        >
          Clear
        </button>
        <button
          type="button"
          class="qp-btn qp-btn--primary"
          (click)="submitQuickText()"
          [disabled]="!quickText.trim()"
        >
          <i class="pi pi-plus-circle"></i>
          Add to Prescription
        </button>
      </div>
    </footer>
  </aside>
</div>

<!-- ═══ Add New Patient Dialog ═══ -->
<p-dialog
  [(visible)]="showAddPatientDialog"
  [modal]="true"
  [style]="{ width: '580px', maxWidth: '96vw' }"
  [draggable]="false"
  [resizable]="false"
  styleClass="ap-dialog"
>
  <ng-template pTemplate="header">
    <div class="ap-dialog__header">
      <span class="ap-dialog__icon"><i class="pi pi-user-plus"></i></span>
      <div>
        <h2 class="ap-dialog__title">Add New Patient</h2>
        <p class="ap-dialog__subtitle">Register a patient and start consultation</p>
      </div>
    </div>
  </ng-template>

  <div class="ap-form">
    <section class="ap-section">
      <div class="ap-section__label">
        <i class="pi pi-id-card"></i>
        <span>Identity</span>
      </div>
      <div class="ap-row ap-row--3">
        <div class="ap-field">
          <label>First Name <span class="ap-req">*</span></label>
          <input
            pInputText
            [(ngModel)]="newPatient.first_name"
            placeholder="First name"
            class="ap-input"
          />
        </div>
        <div class="ap-field">
          <label>Middle Name</label>
          <input
            pInputText
            [(ngModel)]="newPatient.middle_name"
            placeholder="Middle name"
            class="ap-input"
          />
        </div>
        <div class="ap-field">
          <label>Last Name <span class="ap-req">*</span></label>
          <input
            pInputText
            [(ngModel)]="newPatient.last_name"
            placeholder="Last name"
            class="ap-input"
          />
        </div>
      </div>
    </section>

    <section class="ap-section">
      <div class="ap-section__label">
        <i class="pi pi-phone"></i>
        <span>Contact</span>
      </div>
      <div class="ap-row ap-row--contact">
        <div class="ap-field ap-field--grow">
          <label>Mobile <span class="ap-req">*</span></label>
          <div class="ap-input-wrap">
            <i class="pi pi-mobile ap-input-icon"></i>
            <input
              pInputText
              [(ngModel)]="newPatient.primary_contact"
              placeholder="10-digit mobile"
              maxlength="10"
              class="ap-input ap-input--with-icon"
              (blur)="checkDuplicatePatient()"
              (ngModelChange)="clearDuplicateWarning()"
            />
            <i
              *ngIf="checkingDuplicate"
              class="pi pi-spin pi-spinner ap-check-spinner"
            ></i>
          </div>
        </div>
        <div class="ap-field ap-field--gender-inline">
          <label>Gender <span class="ap-req">*</span></label>
          <div class="ap-gender-options">
            <label class="ap-gender-pill" *ngFor="let option of genderOptions">
              <input
                type="radio"
                name="apGender"
                [value]="option.value"
                [(ngModel)]="newPatient.gender"
              />
              <span>
                <i class="pi" [ngClass]="option.icon"></i>
                {{ option.label }}
              </span>
            </label>
          </div>
        </div>
      </div>
    </section>

    <section class="ap-section">
      <div class="ap-section__label">
        <i class="pi pi-map-marker"></i>
        <span>Details</span>
      </div>
      <div class="ap-row ap-row--2">
        <div class="ap-field ap-field--age">
          <label>Age (yrs) <span class="ap-req">*</span></label>
          <div class="age-input-with-hint">
            <input
              pInputText
              type="number"
              step="any"
              min="0"
              max="150"
              [ngModel]="newPatient.age"
              (ngModelChange)="onNewPatientAgeChange($event)"
              (blur)="onNewPatientAgeBlur()"
              placeholder="e.g. 2.08"
              class="ap-input age-input-with-hint__input"
            />
            <small class="age-input-with-hint__text text-muted">
              <i class="pi pi-info-circle"></i>{{ patientAgeHint }}
            </small>
          </div>
          <small class="text-danger d-block" *ngIf="newPatientAgeError">{{ newPatientAgeError }}</small>
        </div>
        <div class="ap-field">
          <label>City</label>
          <input
            pInputText
            [(ngModel)]="newPatient.city"
            placeholder="City"
            class="ap-input"
          />
        </div>
      </div>
      <div class="ap-field ap-field--full">
        <label>Blood Group</label>
        <div class="ap-blood-options">
          <label class="ap-blood-pill" *ngFor="let option of bloodGroupOptions">
            <input
              type="radio"
              name="apBloodGroup"
              [value]="option.value"
              [(ngModel)]="newPatient.blood_group"
            />
            <span>{{ option.label }}</span>
          </label>
        </div>
      </div>
      <div class="ap-field ap-field--full">
        <label>Address</label>
        <textarea
          pInputTextarea
          [(ngModel)]="newPatient.address"
          rows="2"
          placeholder="Street address"
          class="ap-input ap-textarea"
        ></textarea>
      </div>
    </section>

    <div class="ap-duplicate-alert" *ngIf="duplicatePatient">
      <span class="ap-duplicate-alert__icon"><i class="pi pi-exclamation-triangle"></i></span>
      <div class="ap-dup-info">
        <strong>Patient with this number already exists</strong>
        <span class="ap-dup-match">
          {{ duplicatePatient.first_name }} {{ duplicatePatient.middle_name }}
          {{ duplicatePatient.last_name }} · #{{ duplicatePatient.patient_number }} ·
          {{ duplicatePatient.primary_contact }}
        </span>
        <span class="ap-dup-hint">
          Family members sometimes share numbers. Confirm only if this is a different person.
        </span>
        <label class="ap-dup-confirm">
          <input type="checkbox" [(ngModel)]="confirmDuplicateOverride" />
          <span>Yes, this is a different person — save anyway</span>
        </label>
      </div>
    </div>
  </div>

  <ng-template pTemplate="footer">
    <div class="ap-footer">
      <span class="ap-footer__hint">
        <span class="ap-req">*</span> Required fields
      </span>
      <div class="ap-footer__actions">
        <button
          type="button"
          class="ap-btn ap-btn--cancel"
          (click)="showAddPatientDialog = false"
        >
          Cancel
        </button>
        <button
          type="button"
          class="ap-btn ap-btn--save"
          (click)="saveNewPatient()"
          [disabled]="
            !newPatient.first_name ||
            !newPatient.last_name ||
            !isValidPatientAge(newPatient.age) ||
            !newPatient.primary_contact ||
            !newPatient.gender ||
            savingNewPatient ||
            (!!duplicatePatient && !confirmDuplicateOverride) ||
            checkingDuplicate
          "
        >
          <i
            class="pi"
            [ngClass]="savingNewPatient ? 'pi-spin pi-spinner' : 'pi-check'"
          ></i>
          {{ savingNewPatient ? 'Saving…' : 'Save Patient' }}
        </button>
      </div>
    </div>
  </ng-template>
</p-dialog>

<p-dialog
  header="Medicine Search"
  [(visible)]="medicineSearchDialogVisible"
  [modal]="true"
  [maximizable]="true"
  [style]="{ width: '72rem', maxWidth: '96vw' }"
  [breakpoints]="{ '1200px': '88vw', '768px': '96vw' }"
  styleClass="medicine-search-modal"
  [draggable]="false"
  [resizable]="false"
>
  <div class="medicine-search-dialog">
    <div class="medicine-search-controls">
      <div class="medicine-search-toolbar">
        <div class="medicine-search-input-wrap">
          <i class="pi pi-search"></i>
          <input
            type="text"
            class="form-control medicine-search-input"
            [(ngModel)]="medicineSearchKeyword"
            (keydown.enter)="searchMedicineFinder()"
            placeholder="Try fever, cough, colitis, typhoid"
          />
        </div>

        <button
          pButton
          type="button"
          label="Search"
          icon="pi pi-search"
          class="p-button-sm medicine-search-btn"
          [disabled]="medicineSearchLoading"
          (click)="searchMedicineFinder(1)"
        ></button>

        <button
          pButton
          type="button"
          label="Clear"
          class="p-button-sm p-button-outlined medicine-search-clear"
          [disabled]="!medicineSearchKeyword && !medicineSearchResults.length"
          (click)="clearMedicineSearch()"
        ></button>
      </div>

      <div class="medicine-search-chips">
        <button type="button" (click)="quickMedicineSearch('fever')">
          fever
        </button>
        <button type="button" (click)="quickMedicineSearch('cough')">
          cough
        </button>
        <button type="button" (click)="quickMedicineSearch('colitis')">
          colitis
        </button>
        <button type="button" (click)="quickMedicineSearch('typhoid')">
          typhoid
        </button>
        <button type="button" (click)="quickMedicineSearch('diarrhoea')">
          diarrhoea
        </button>
      </div>

      <div class="medicine-search-summary">
        <div class="medicine-search-summary-item">
          <span>Visible</span>
          <strong>{{ medicineSearchResultCount }}</strong>
        </div>
        <div
          class="medicine-search-summary-item"
          *ngIf="medicineSearchResults.length"
        >
          <span>Authors</span>
          <strong>{{ medicineSearchUniqueAuthors }}</strong>
        </div>
        <div
          class="medicine-search-summary-item"
          *ngIf="medicineSearchTotal !== null"
        >
          <span>Total</span>
          <strong>{{ medicineSearchTotal }}</strong>
        </div>
        <div class="medicine-search-summary-note">
          Scan left to right: disease, medicine, drug, author.
        </div>
      </div>

      <div
        class="medicine-search-pagination"
        *ngIf="medicineSearchResults.length"
      >
        <div class="medicine-search-page-summary">
          Showing {{ medicineSearchVisibleStart }}-{{
            medicineSearchVisibleEnd
          }}
          <ng-container *ngIf="medicineSearchTotal !== null">
            of {{ medicineSearchTotal }}
          </ng-container>
        </div>

        <div class="medicine-search-page-actions">
          <button
            pButton
            type="button"
            label="Previous"
            class="p-button-sm p-button-outlined medicine-search-page-btn medicine-search-page-btn-prev"
            [disabled]="medicineSearchPage <= 1 || medicineSearchLoading"
            (click)="goToPreviousMedicineSearchPage()"
          ></button>

          <span class="medicine-search-page-chip"
            >Page {{ medicineSearchPage }}</span
          >

          <button
            pButton
            type="button"
            label="Next"
            class="p-button-sm medicine-search-page-btn medicine-search-page-btn-next"
            [disabled]="!medicineSearchHasMore || medicineSearchLoading"
            (click)="goToNextMedicineSearchPage()"
          ></button>
        </div>
      </div>
    </div>

    <div *ngIf="medicineSearchError" class="medicine-search-state error">
      {{ medicineSearchError }}
    </div>
    <div *ngIf="medicineSearchLoading" class="medicine-search-state loading">
      <span class="medicine-search-loader"></span>
      <div>
        <strong>Searching…</strong>
        <div>Finding the best matching remedies for your keyword.</div>
      </div>
    </div>
    <div
      *ngIf="
        !medicineSearchLoading &&
        !medicineSearchError &&
        !medicineSearchResults.length
      "
      class="medicine-search-state empty"
    >
      <div class="medicine-search-empty-icon">⌕</div>
      <div>
        <strong>Start with a symptom keyword</strong>
        <div>Search results will appear here in a scan-friendly layout.</div>
      </div>
    </div>

    <div *ngIf="medicineSearchResults.length" class="medicine-search-results">
      <div class="medicine-search-table-head">
        <div>No.</div>
        <div>Disease</div>
        <div>Medicine</div>
        <div>Drug</div>
        <div>Author</div>
      </div>

      <div
        class="medicine-search-row"
        *ngFor="let item of medicineSearchResults; let idx = index"
      >
        <div class="medicine-search-cell medicine-search-cell-no">
          <span class="medicine-search-result-no"
            >#{{ medicineSearchVisibleStart + idx }}</span
          >
        </div>

        <div class="medicine-search-cell medicine-search-cell-disease">
          <div
            class="medicine-search-disease"
            [innerHTML]="highlightMedicineSearchMatch(item.disease)"
          ></div>
          <div class="medicine-search-meta">
            <span class="medicine-search-meta-chip">ID #{{ item.id }}</span>
            <span class="medicine-search-meta-chip"
              >Tridosha: {{ item.tridosha || "-" }}</span
            >
            <span class="medicine-search-meta-chip"
              >PSS: {{ item.pss || "-" }}</span
            >
          </div>
          <div
            class="medicine-search-searchtext"
            *ngIf="item.search_text"
            [innerHTML]="highlightMedicineSearchMatch(item.search_text)"
          ></div>
        </div>

        <div class="medicine-search-cell medicine-search-cell-medicine">
          <span class="medicine-search-mobile-label">Medicine</span>
          <strong>{{ item.medicine || "-" }}</strong>
        </div>

        <div class="medicine-search-cell medicine-search-cell-drug">
          <span class="medicine-search-mobile-label">Drug</span>
          <strong>{{ item.drug || "-" }}</strong>
        </div>

        <div class="medicine-search-cell medicine-search-cell-author">
          <span class="medicine-search-mobile-label">Author</span>
          <span class="medicine-search-author">{{
            item.author || "Unknown"
          }}</span>
        </div>
      </div>
    </div>
  </div>
</p-dialog>

<p-dialog
  [(visible)]="repertoryDialogVisible"
  [modal]="true"
  [maximizable]="true"
  [style]="{ width: 'min(92vw, 1320px)' }"
  [breakpoints]="{ '1200px': '94vw', '768px': '96vw' }"
  [contentStyle]="{ padding: '0', overflow: 'hidden', display: 'flex', flexDirection: 'column', minHeight: '0' }"
  styleClass="rep-dialog"
  [draggable]="false"
  [resizable]="false"
>
  <ng-template pTemplate="header">
    <div class="rep-dialog-head">
      <div class="rep-dialog-head__brand">
        <span class="rep-dialog-head__icon"><i class="pi pi-book"></i></span>
        <div class="rep-dialog-head__copy">
          <span class="rep-dialog-eyebrow">Clinical tools</span>
          <h2 class="rep-dialog-title">Repertory workspace</h2>
          <p class="rep-dialog-sub">
            Choose the prescription row below, then click remedies to insert. Switch rows anytime without closing.
          </p>
        </div>
      </div>
      <div class="rep-dialog-head__meta" *ngIf="repertoryTargetLabel">
        <span class="rep-dialog-target">
          <i class="pi pi-map-marker"></i>
          <span>{{ repertoryTargetLabel }}</span>
        </span>
        <span class="rep-dialog-target-hint">Active insert target</span>
      </div>
    </div>
  </ng-template>

  <div class="rep-dialog-shell" *ngIf="repertoryDialogVisible">
    <section class="rep-target-bar">
      <span class="rep-target-bar__label">Insert into</span>
      <div class="rep-target-bar__groups">
        @for (group of getRepertoryTargetGroups(); track group.pIndex) {
          <div class="rep-target-bar__group">
            <span class="rep-target-bar__rx">Rx {{ group.pIndex + 1 }}</span>
            <div class="rep-target-bar__rows">
              @for (row of group.rows; track row.mIndex) {
                <button
                  type="button"
                  class="rep-target-chip"
                  [class.rep-target-chip--active]="isRepertoryTargetActive(group.pIndex, row.mIndex)"
                  [class.rep-target-chip--empty]="row.isEmpty"
                  (click)="setRepertoryTarget(group.pIndex, row.mIndex)"
                  [title]="row.summary"
                >
                  <span class="rep-target-chip__text">
                    R{{ row.mIndex + 1 }}<span class="rep-target-chip__sep">·</span>{{ row.summary }}
                  </span>
                </button>
              }
              <button
                type="button"
                class="rep-target-chip rep-target-chip--add"
                (click)="addMedicineRowFromRepertory(group.pIndex)"
                title="Add row"
                aria-label="Add row"
              >
                <i class="pi pi-plus"></i>
              </button>
            </div>
          </div>
        }
      </div>
      <button
        type="button"
        class="rep-target-bar__quick-btn"
        (click)="jumpToNextEmptyRepertoryRow()"
        title="Next empty row"
        aria-label="Next empty row"
      >
        <i class="pi pi-angle-double-right"></i>
      </button>
    </section>

    <app-repertory-panel
      mode="dialog"
      [selectionMode]="true"
      [initialSymptom]="repertoryInitialSymptom"
      [targetLabel]="repertoryTargetLabel"
      [preferredPotency]="getRepertoryPreferredPotency()"
      (remedySelected)="onRepertoryRemedySelected($event)"
    ></app-repertory-panel>
  </div>

  <ng-template pTemplate="footer">
    <div class="rep-dialog-footer">
      <div class="rep-dialog-footer__left">
        <span class="rep-dialog-footer__hint">
          <i class="pi pi-info-circle"></i>
          Switch rows in the bar above, then keep adding remedies.
        </span>
        <span class="rep-dialog-footer__count" *ngIf="repertorySessionCount > 0">
          <i class="pi pi-check-circle"></i>
          {{ repertorySessionCount }} added this session
        </span>
      </div>
      <div class="rep-dialog-footer__actions">
        <button
          type="button"
          pButton
          label="Done"
          icon="pi pi-check"
          class="rep-dialog-done-btn"
          (click)="closeRepertoryDialog()"
        ></button>
      </div>
    </div>
  </ng-template>
</p-dialog>

<p-dialog
  header="Doctor Notes"
  [(visible)]="doctorNotesDialogVisible"
  [modal]="true"
  [maximizable]="true"
  [style]="{ width: '42rem' }"
  [draggable]="false"
  [resizable]="false"
>
  <div class="doctor-notes-dialog">
    <div class="doctor-notes-tabs">
      <button
        type="button"
        class="doctor-notes-tab-btn"
        [ngClass]="{ active: doctorNotesTab === 'notes' }"
        (click)="doctorNotesTab = 'notes'"
      >
        Doctor Notes
      </button>
      <button
        type="button"
        class="doctor-notes-tab-btn"
        [ngClass]="{ active: doctorNotesTab === 'instructions' }"
        (click)="doctorNotesTab = 'instructions'"
      >
        Special Instructions
      </button>
    </div>

    <div *ngIf="doctorNotesTab === 'notes'">
      <div
        *ngIf="latestDoctorNote; else noDoctorNotes"
        class="latest-doctor-note"
      >
        <div class="latest-note-title">
          Last Prescription Note
          <span *ngIf="latestDoctorNoteDate" class="latest-note-date"
            >({{ latestDoctorNoteDate }})</span
          >
        </div>
        <div class="latest-note-body">{{ latestDoctorNote }}</div>
      </div>

      <ng-template #noDoctorNotes>
        <div class="no-doctor-notes">
          No previous doctor notes found for this patient.
        </div>
      </ng-template>

      <div *ngIf="doctorNotesHistory.length > 1" class="doctor-note-history">
        <div class="history-title">Older Notes</div>
        <ng-container *ngFor="let note of doctorNotesHistory; let i = index">
          <div *ngIf="i > 0" class="history-note-item">
            <div class="history-note-date">{{ note.date }}</div>
            <div class="history-note-text">{{ note.notes }}</div>
          </div>
        </ng-container>
      </div>
    </div>

    <div *ngIf="doctorNotesTab === 'instructions'">
      <div
        *ngIf="latestSpecialInstruction; else noSpecialInstructions"
        class="latest-doctor-note"
      >
        <div class="latest-note-title">
          Last Special Instruction
          <span *ngIf="latestSpecialInstructionDate" class="latest-note-date"
            >({{ latestSpecialInstructionDate }})</span
          >
        </div>
        <div class="latest-note-body">{{ latestSpecialInstruction }}</div>
      </div>

      <ng-template #noSpecialInstructions>
        <div class="no-doctor-notes">
          No previous special instructions found for this patient.
        </div>
      </ng-template>

      <div
        *ngIf="specialInstructionsHistory.length > 1"
        class="doctor-note-history"
      >
        <div class="history-title">Older Special Instructions</div>
        <ng-container
          *ngFor="let note of specialInstructionsHistory; let i = index"
        >
          <div *ngIf="i > 0" class="history-note-item">
            <div class="history-note-date">{{ note.date }}</div>
            <div class="history-note-text">{{ note.notes }}</div>
          </div>
        </ng-container>
      </div>
    </div>
  </div>
</p-dialog>

<!-- Historical Rx Preview Modal -->
<p-dialog
  header="Preview Prescription"
  [(visible)]="displayHistoricalRxPreview"
  [modal]="true"
  [style]="{ width: '65vw' }"
  [draggable]="false"
  [resizable]="false"
  styleClass="rx-preview-dialog"
>
  <ng-template pTemplate="header">
    <div class="d-flex flex-column" *ngIf="previewRx">
      <span class="fs-5 fw-bold text-dark">🩺 {{previewRx.matched_title}}</span>
      <span class="text-muted" style="font-size: 13px;">
        {{previewRx.patient_name}} • {{previewRx.date}}
      </span>
    </div>
  </ng-template>

  <div class="p-3" *ngIf="previewRx">
    <div
      *ngFor="let block of previewRx.raw_prescription; let i = index"
      class="rx-history-prescription-card"
    >
      <div class="rx-history-rx-head">
        <div class="d-flex align-items-center gap-2">
          <h6 class="fw-bold text-success mb-1">
            Rx {{ i + 1 }}
          </h6>
          <div
            *ngIf="block.title"
            class="rx-history-rx-title"
          >
            {{ block.title }}
          </div>
        </div>
        <div class="d-flex align-items-center gap-2">
          <span
            *ngIf="block.duration"
            class="badge rounded-pill bg-light-green text-dark"
          >
            {{ block.duration }}
          </span>
        </div>
      </div>

      <div
        *ngIf="block.medicines?.length"
        class="table-responsive"
      >
        <table
          class="table table-sm table-bordered align-middle rx-history-rx-table"
        >
          <thead>
            <tr>
              <th>#</th>
              <th>Medicine</th>
              <th>Dose</th>
              <th>Schedule</th>
            </tr>
          </thead>
          <tbody>
            <ng-container
              *ngFor="
                let med of block.medicines;
                let k = index
              "
            >
              <tr
                *ngIf="
                  med.tags?.length || med.drams || med.ballers
                "
              >
                <td>{{ k + 1 }}</td>
                <td>
                  <span
                    class="tag-chip gap-3 ml-1"
                    *ngFor="let tag of med.tags"
                  >
                    <span class="ml-1">
                      {{ tag.name }} (
                      <ng-container
                        *ngIf="
                          getCodeParts(tag.code) as codeParts
                        "
                      >
                        <span
                          [class.rx-potency-key]="
                            codeParts.hasHighlight
                          "
                          >{{ codeParts.prefix
                          }}{{ codeParts.suffix }}</span
                        >
                      </ng-container>
                      -
                      <ng-container
                        *ngIf="
                          getPotencyParts(
                            tag.potency
                          ) as potencyParts
                        "
                      >
                        <ng-container
                          *ngIf="
                            potencyParts.hasHighlight;
                            else plainPotencyC
                          "
                        >
                          <span class="rx-potency-key">{{
                            potencyParts.prefix
                          }}</span
                          >{{ potencyParts.suffix }}
                        </ng-container>
                        <ng-template #plainPotencyC>{{
                          potencyParts.prefix
                        }}</ng-template>
                      </ng-container>
                      )
                    </span>
                  </span>
                </td>
                <td>{{ med.drams }}</td>
                <td>{{ med.ballers }}</td>
              </tr>
            </ng-container>
          </tbody>
        </table>
      </div>
    </div>
  </div>

  <ng-template pTemplate="footer">
    <div class="rx-preview-footer">
      <button
        type="button"
        class="rx-preview-btn rx-preview-btn--cancel"
        (click)="displayHistoricalRxPreview = false"
      >
        <i class="pi pi-times"></i>
        <span>Cancel</span>
      </button>
      <button
        type="button"
        class="rx-preview-btn rx-preview-btn--load"
        (click)="importAllHistoricalMeds()"
      >
        <i class="pi pi-file-import"></i>
        <span>Load Rx</span>
      </button>
    </div>
  </ng-template>
</p-dialog>

<p-dialog
  [(visible)]="reportAnalysisDialogVisible"
  [modal]="true"
  [style]="{ width: 'min(96vw, 1240px)' }"
  [contentStyle]="{ padding: '0', overflow: 'hidden', display: 'flex', flexDirection: 'column', minHeight: '0' }"
  [draggable]="false"
  [resizable]="false"
  styleClass="ra-dialog"
>
  <ng-template pTemplate="header">
    <div class="ra-dialog-head" *ngIf="selectedReportFile">
      <div class="ra-dialog-head__brand">
        <div class="ra-dialog-head__icon">
          <i class="pi" [ngClass]="aiEnabled ? 'pi-sparkles' : 'pi-file'"></i>
        </div>
        <div>
          <div class="ra-dialog-eyebrow">{{ aiEnabled ? 'Report AI Analysis' : 'Report Analysis' }}</div>
          <div class="ra-dialog-title">{{ selectedReportFile.name }}</div>
          <div class="ra-dialog-sub">
            Decision support only. Findings suggest possible changes; they do not prove causation.
          </div>
        </div>
      </div>
      <div class="ra-dialog-head__meta">
        <span class="ra-kind-chip" [ngClass]="getReportKindClass(selectedReportFile)">
          <i [class]="getReportKindIcon(selectedReportFile)"></i>
          {{ getReportKindLabel(selectedReportFile) }}
        </span>
        <span
          class="ra-status-chip"
          [ngClass]="getReportStatusClass(selectedReportFile)"
          *ngIf="aiEnabled"
        >
          {{ getReportStatusLabel(selectedReportFile) }}
        </span>
      </div>
    </div>
  </ng-template>

  <div class="ra-shell" *ngIf="selectedReportFile" id="printable-report-analysis">
    <aside class="ra-preview">
      <button
        type="button"
        class="ra-preview__doc-link"
        [class.ra-preview__doc-link--disabled]="!canOpenReportDocument(selectedReportFile)"
        [disabled]="!canOpenReportDocument(selectedReportFile)"
        [title]="
          isTextReport(selectedReportFile)
            ? 'Read full text report'
            : (canOpenReportDocument(selectedReportFile) ? 'Open document in new tab' : 'Document preview unavailable')
        "
        (click)="openReportDocument(selectedReportFile)"
      >
        <div class="ra-preview__frame" [ngClass]="getReportKindClass(selectedReportFile)">
          <img
            *ngIf="!isTextReport(selectedReportFile) && selectedReportFile.type?.startsWith('image/')"
            [src]="selectedReportFile.url"
            alt="Report preview"
            class="ra-preview__image"
          />
          <div
            *ngIf="isTextReport(selectedReportFile)"
            class="ra-preview__text-body"
          >
            {{ getTextReportExcerpt(selectedReportFile, 420) }}
          </div>
          <div
            *ngIf="!isTextReport(selectedReportFile) && !selectedReportFile.type?.startsWith('image/')"
            class="ra-preview__placeholder"
          >
            <i [class]="getReportKindIcon(selectedReportFile)"></i>
          </div>
          <span class="ra-preview__open-badge" *ngIf="canOpenReportDocument(selectedReportFile)">
            <i class="pi" [ngClass]="isTextReport(selectedReportFile) ? 'pi-book' : 'pi-external-link'"></i>
            {{ isTextReport(selectedReportFile) ? 'Read' : 'Open' }}
          </span>
        </div>
        <div class="ra-preview__meta ra-preview__meta--doc">
          <div class="ra-preview__label">Document</div>
          <div class="ra-preview__value">{{ selectedReportFile.name }}</div>
        </div>
      </button>
      <div class="ra-preview__meta">
        <div class="ra-preview__label">Uploaded</div>
        <div class="ra-preview__value">{{ selectedReportFile.uploaded_at || '—' }}</div>
      </div>
    </aside>

    <main class="ra-main">
      <nav class="ra-tabs" aria-label="Report analysis sections">
        <button
          type="button"
          class="ra-tab"
          *ngFor="let tab of reportAnalysisTabs"
          [class.ra-tab--active]="reportAnalysisTabIndex === tab.index"
          (click)="setReportAnalysisTab(tab.index)"
        >
          <i [class]="tab.icon"></i>
          <span>{{ tab.label }}</span>
        </button>
      </nav>

      <div class="ra-panel-scroll">
        <section class="ra-panel" *ngIf="reportAnalysisTabIndex === 0">
          <div class="ra-cta ra-cta--extract" *ngIf="shouldShowExtractionCta()">
            <div class="ra-cta__icon" aria-hidden="true">
              <i class="pi" [ngClass]="isExtractionAnalyzing() ? 'pi-spin pi-spinner' : 'pi-sparkles'"></i>
            </div>
            <div class="ra-cta__body">
              <div class="ra-cta__title">{{ getExtractionCtaTitle() }}</div>
              <div class="ra-cta__hint">{{ getExtractionCtaHint() }}</div>
            </div>
            <button
              pButton
              type="button"
              class="ra-cta__btn ra-cta__btn--extract"
              [loading]="isExtractionAnalyzing()"
              [disabled]="isExtractionAnalyzing()"
              (click)="runReportExtraction()"
            >
              <i class="pi pi-sparkles" *ngIf="!isExtractionAnalyzing()"></i>
              <span>{{ getExtractionActionLabel() }}</span>
            </button>
          </div>

          <div
            class="ra-extraction-ready"
            *ngIf="!shouldShowExtractionCta() && !reportAnalysisLoading && hasSuccessfulExtraction()"
          >
            <i class="pi pi-check-circle"></i>
            <div>
              <strong>Markers extracted</strong>
              <span>Analysis ran automatically when this report was uploaded.</span>
            </div>
          </div>

          <div class="ra-loading-card" *ngIf="reportAnalysisLoading || (isExtractionAnalyzing() && !reportExtractionAnalysis)">
            <i class="pi pi-spin pi-spinner"></i>
            <span>{{ isExtractionAnalyzing() ? 'Extracting markers…' : 'Loading analysis results…' }}</span>
          </div>

          <ng-container *ngIf="!reportAnalysisLoading && reportExtractionAnalysis as extraction">
            <div class="ra-metrics-strip">
              <article class="ra-metrics-strip__stat ra-metrics-strip__stat--confidence">
                <div class="ra-metrics-strip__row">
                  <span class="ra-metrics-strip__label">Confidence</span>
                  <strong class="ra-metrics-strip__value">{{ getConfidencePercent(extraction.confidence) }}%</strong>
                </div>
                <div class="ra-confidence ra-confidence--strip">
                  <div
                    class="ra-confidence__fill ra-confidence__fill--outcome"
                    [style.width.%]="getConfidencePercent(extraction.confidence)"
                  ></div>
                </div>
              </article>
              <article class="ra-metrics-strip__stat ra-metrics-strip__stat--quality">
                <span class="ra-metrics-strip__label">Quality</span>
                <span class="ra-quality-chip" [ngClass]="getQualityClass(extraction.quality_status)">
                  {{ getQualityLabel(extraction.quality_status) }}
                </span>
              </article>
              <article class="ra-metrics-strip__stat">
                <span class="ra-metrics-strip__label">Markers</span>
                <strong class="ra-metrics-strip__value">{{ extraction.markers?.length || 0 }}</strong>
              </article>
              <article class="ra-metrics-strip__stat ra-metrics-strip__stat--alert">
                <span class="ra-metrics-strip__label">Abnormal</span>
                <strong class="ra-metrics-strip__value">{{ getAbnormalMarkerCount(extraction.markers) }}</strong>
              </article>
            </div>

            <div class="ra-insight-card">
              <div class="ra-insight-card__head">
                <i class="pi pi-file-edit"></i>
                <span>AI Summary</span>
              </div>
              <p>{{ extraction.summary_text || 'No summary available.' }}</p>
            </div>

            <div
              class="ra-alert"
              *ngIf="extraction.quality_status === 'needs_reupload' || extraction.quality_status === 'poor'"
            >
              <i class="pi pi-exclamation-triangle"></i>
              <div>
                <strong>Low report quality</strong>
                <p>Re-upload a clearer scan or photo if this is a lab report. Prescription-only documents may not contain extractable markers.</p>
              </div>
            </div>

            <div class="ra-markers-grid" *ngIf="extraction.markers?.length; else noMarkers">
              <article
                class="ra-marker-card"
                *ngFor="let marker of extraction.markers"
                [ngClass]="'ra-marker-card--' + getMarkerFlagCssKey(marker.flag)"
              >
                <div class="ra-marker-card__top">
                  <div class="ra-marker-card__name">{{ marker.marker_name }}</div>
                  <span class="ra-flag" [ngClass]="'ra-flag--' + getMarkerFlagCssKey(marker.flag)">
                    {{ getMarkerFlagLabel(marker.flag) }}
                  </span>
                </div>
                <div class="ra-marker-card__value" [class.ra-marker-card__value--abnormal]="!isMarkerValueInRange(marker)">
                  {{ marker.value_numeric ?? marker.value_text ?? '—' }}
                  <span *ngIf="marker.unit">{{ marker.unit }}</span>
                </div>
                <div class="ra-marker-card__ref" *ngIf="marker.reference_low != null || marker.reference_high != null">
                  Ref: {{ marker.reference_low ?? '—' }} – {{ marker.reference_high ?? '—' }}
                </div>
                <!-- Reference range gauge bar -->
                <div class="ra-marker-gauge" *ngIf="calculateGaugePosition(marker) !== null">
                  <div class="ra-marker-gauge__range"></div>
                  <div
                    class="ra-marker-gauge__pin"
                    [style.left.%]="calculateGaugePosition(marker)"
                    [class.ra-marker-gauge__pin--abnormal]="!isMarkerValueInRange(marker)"
                  ></div>
                </div>
              </article>
            </div>
            <ng-template #noMarkers>
              <div class="ra-empty-card">
                <i class="pi pi-inbox"></i>
                <strong>No markers extracted</strong>
                <span>Try a clearer lab report or a different document type.</span>
              </div>
            </ng-template>
          </ng-container>

          <div
            class="ra-empty-card"
            *ngIf="!reportAnalysisLoading && !reportExtractionAnalysis && !isExtractionAnalyzing()"
          >
            <i class="pi pi-sparkles"></i>
            <strong>No extraction yet</strong>
            <span *ngIf="aiEnabled">Your document is saved. Analysis runs automatically after upload, or use Analyze Report to retry.</span>
            <span *ngIf="!aiEnabled">Your document is saved. AI analysis is currently turned off.</span>
          </div>
        </section>

        <section class="ra-panel" *ngIf="reportAnalysisTabIndex === 1 && analysisTabRenderReady">
          <div class="ra-baseline-picker" aria-label="Baseline report selection">
            <div class="ra-baseline-picker__header">
              <div>
                <div class="ra-baseline-picker__title">Compare against</div>
                <p class="ra-baseline-picker__subtitle">
                  Tap a ready report below, or use Auto to pick the best prior match.
                </p>
              </div>
              <button
                type="button"
                class="ra-baseline-auto-btn"
                [class.ra-baseline-auto-btn--active]="isBaselineAutoMode()"
                (click)="clearBaselineSelection()"
              >
                <i class="pi pi-bolt"></i>
                <span>Auto</span>
              </button>
            </div>

            <div class="ra-baseline-versus">
              <div class="ra-baseline-versus__node ra-baseline-versus__node--current">
                <span class="ra-baseline-versus__label">Current</span>
                <div class="ra-baseline-versus__card">
                  <span class="ra-baseline-versus__icon" [ngClass]="getReportKindClass(selectedReportFile)">
                    <i [class]="getReportKindIcon(selectedReportFile)"></i>
                  </span>
                  <div class="ra-baseline-versus__meta">
                    <strong>{{ getCurrentReportLabel() }}</strong>
                    <span>{{ getCurrentReportDateLabel() }}</span>
                  </div>
                </div>
              </div>
              <div class="ra-baseline-versus__arrow" aria-hidden="true">
                <i class="pi pi-arrow-right"></i>
              </div>
              <div class="ra-baseline-versus__node ra-baseline-versus__node--baseline">
                <span class="ra-baseline-versus__label">Baseline</span>
                <div
                  class="ra-baseline-versus__card"
                  [class.ra-baseline-versus__card--auto]="isBaselineAutoMode()"
                >
                  <span
                    class="ra-baseline-versus__icon ra-baseline-versus__icon--auto"
                    *ngIf="isBaselineAutoMode(); else baselineSelectedIcon"
                  >
                    <i class="pi pi-bolt"></i>
                  </span>
                  <ng-template #baselineSelectedIcon>
                    <span
                      class="ra-baseline-versus__icon"
                      [ngClass]="getSelectedBaselineOption()?.kindClass"
                      *ngIf="getSelectedBaselineOption() as selectedBaseline"
                    >
                      <i [class]="selectedBaseline.kindIcon"></i>
                    </span>
                  </ng-template>
                  <div class="ra-baseline-versus__meta">
                    <strong>{{ getBaselineReportLabel() }}</strong>
                    <span *ngIf="isBaselineAutoMode()">Most recent matching prior report</span>
                    <span *ngIf="!isBaselineAutoMode() && getSelectedBaselineOption() as selectedBaseline">
                      {{ selectedBaseline.date }} · {{ selectedBaseline.reportTypeLabel }}
                    </span>
                  </div>
                </div>
              </div>
            </div>

            <div class="ra-baseline-picker__toolbar">
              <span class="ra-baseline-picker__count">
                <i class="pi pi-list-check"></i>
                Select baseline
                <em>{{ getReadyBaselineCandidates().length }} ready</em>
              </span>
              <div class="ra-baseline-search" *ngIf="baselineReportCandidates.length > 3">
                <i class="pi pi-search"></i>
                <input
                  type="search"
                  placeholder="Search prior reports…"
                  [(ngModel)]="baselineSearchQuery"
                  (ngModelChange)="applyBaselineFilter()"
                />
              </div>
            </div>

            <div class="ra-baseline-picker__scroll">
              <div class="ra-baseline-empty" *ngIf="!baselineReportCandidates.length">
                <i class="pi pi-inbox"></i>
                <strong>No prior reports</strong>
                <span>Upload an earlier report to enable comparison and outcome analysis.</span>
              </div>

              <div
                class="ra-baseline-list"
                *ngIf="getReadyBaselineCandidates().length"
                role="radiogroup"
                aria-label="Select baseline report"
              >
                <button
                  type="button"
                  class="ra-baseline-option"
                  *ngFor="let item of getReadyBaselineCandidates()"
                  [class.ra-baseline-option--selected]="isBaselineSelected(item)"
                  [attr.aria-checked]="isBaselineSelected(item)"
                  role="radio"
                  [pTooltip]="getBaselineOptionTooltip(item)"
                  tooltipPosition="top"
                  appendTo="body"
                  tooltipStyleClass="pc-gallery-insight-tooltip"
                  (click)="selectBaselineReport(item)"
                >
                  <span
                    class="ra-baseline-option__radio"
                    [class.ra-baseline-option__radio--on]="isBaselineSelected(item)"
                    aria-hidden="true"
                  >
                    <span class="ra-baseline-option__radio-dot"></span>
                  </span>
                  <span class="ra-baseline-option__icon" [ngClass]="item.kindClass">
                    <i [class]="item.kindIcon"></i>
                  </span>
                  <span class="ra-baseline-option__content">
                    <span class="ra-baseline-option__name" [title]="item.name">{{ item.name }}</span>
                    <span class="ra-baseline-option__meta">
                      <span>{{ item.date }}</span>
                      <span class="ra-baseline-option__sep">·</span>
                      <span>{{ item.reportTypeLabel }}</span>
                      <span class="ra-baseline-option__sep">·</span>
                      <span>{{ item.kindLabel }}</span>
                    </span>
                  </span>
                  <span class="ra-baseline-option__pick" *ngIf="isBaselineSelected(item)">
                    <i class="pi pi-check"></i>
                    Baseline
                  </span>
                </button>
              </div>

              <p class="ra-baseline-picker__pending" *ngIf="getPendingBaselineCount() > 0">
                {{ getPendingBaselineCount() }} other report{{ getPendingBaselineCount() === 1 ? '' : 's' }}
                still analyzing — not available as baseline yet.
              </p>

              <div
                class="ra-baseline-no-results"
                *ngIf="baselineReportCandidates.length && !getReadyBaselineCandidates().length"
              >
                No analyzed reports match your search.
              </div>
            </div>
          </div>

          <div class="ra-cta ra-cta--compare" *ngIf="aiEnabled">
            <div class="ra-cta__icon" aria-hidden="true">
              <i class="pi pi-chart-line"></i>
            </div>
            <div class="ra-cta__body">
              <div class="ra-cta__title">Compare with baseline</div>
              <div class="ra-cta__hint">Deterministic marker diff first, then cautious AI interpretation.</div>
            </div>
            <button
              pButton
              type="button"
              class="ra-cta__btn ra-cta__btn--compare"
              [loading]="reportCompareLoading"
              [disabled]="reportCompareLoading"
              (click)="runReportComparison()"
            >
              <i class="pi pi-chart-line" *ngIf="!reportCompareLoading"></i>
              <span>{{ reportCompareLoading ? 'Comparing…' : 'Run Comparison' }}</span>
            </button>
          </div>

          <div class="ra-loading-card" *ngIf="reportCompareLoading">
            <i class="pi pi-spin pi-spinner"></i>
            <span>Comparing reports…</span>
          </div>

          <ng-container *ngIf="!reportCompareLoading && comparisonDisplay as display">
            <div class="ra-compare-hero">
              <div class="ra-compare-hero__main">
                <span class="ra-response-chip ra-response-chip--lg" [ngClass]="display.likelyResponseClass">
                  {{ display.likelyResponse }}
                </span>
                <p>{{ display.summaryText }}</p>
              </div>
              <div class="ra-compare-hero__confidence">
                <div class="ra-metric__label">Confidence</div>
                <div class="ra-metric__value">{{ display.confidencePercent }}%</div>
                <div class="ra-confidence">
                  <div
                    class="ra-confidence__fill ra-confidence__fill--outcome"
                    [style.width.%]="display.confidencePercent"
                  ></div>
                </div>
              </div>
            </div>

            <div class="ra-diff-stats" *ngIf="display.diff as diff">
              <div class="ra-diff-stat ra-diff-stat--changed">
                <strong>{{ diff.stats.changed }}</strong>
                <span>Changed</span>
              </div>
              <div class="ra-diff-stat ra-diff-stat--added">
                <strong>{{ diff.stats.added }}</strong>
                <span>Added</span>
              </div>
              <div class="ra-diff-stat ra-diff-stat--removed">
                <strong>{{ diff.stats.removed }}</strong>
                <span>Removed</span>
              </div>
              <div class="ra-diff-stat ra-diff-stat--unchanged">
                <strong>{{ diff.stats.unchanged }}</strong>
                <span>Unchanged</span>
              </div>
            </div>

            <div class="ra-interpret-grid">
              <div class="ra-interpret-card" *ngIf="display.supportingChanges.length">
                <div class="ra-interpret-card__title">
                  <i class="pi pi-check-circle"></i> Supporting changes
                </div>
                <ul>
                  <li *ngFor="let item of display.supportingChanges">{{ item }}</li>
                </ul>
              </div>
              <div class="ra-interpret-card ra-interpret-card--caveat" *ngIf="display.caveats.length">
                <div class="ra-interpret-card__title">
                  <i class="pi pi-exclamation-circle"></i> Caveats
                </div>
                <ul>
                  <li *ngFor="let item of display.caveats">{{ item }}</li>
                </ul>
              </div>
            </div>

            <div class="ra-diff-board" *ngIf="display.diff">
              <div class="ra-diff-legend">
                <span class="ra-diff-legend__item ra-diff-trend--favorable">
                  <i class="pi pi-arrow-down"></i> Green = clinically better
                </span>
                <span class="ra-diff-legend__item ra-diff-trend--unfavorable">
                  <i class="pi pi-arrow-up"></i> Red = clinically worse
                </span>
                <span class="ra-diff-legend__item ra-diff-trend--neutral">
                  <i class="pi pi-minus"></i> Gray = unclear / neutral
                </span>
              </div>

              <div class="ra-diff-section" *ngIf="display.diff.changed.length">
                <div class="ra-diff-section__title">
                  <i class="pi pi-arrows-h"></i> Changed markers
                </div>
                <div
                  class="ra-diff-row"
                  *ngFor="let item of display.diff.changed"
                  [ngClass]="getDiffTrendClass(item)"
                >
                  <div class="ra-diff-row__marker">
                    <strong>{{ item.marker_name }}</strong>
                    <span *ngIf="item.unit">{{ item.unit }}</span>
                    <span class="ra-diff-trend-chip" [ngClass]="getDiffTrendClass(item)">
                      {{ getDiffTrendLabel(item) }}
                    </span>
                  </div>
                  <div class="ra-diff-row__values">
                    <span class="ra-diff-value">{{ item.before ?? '—' }}</span>
                    <span
                      class="ra-diff-arrow"
                      [ngClass]="getDiffTrendClass(item)"
                      [pTooltip]="getDiffTrendTooltip(item)"
                      tooltipPosition="top"
                      appendTo="body"
                    >
                      <i [class]="getDiffDirectionIcon(item)"></i>
                    </span>
                    <span
                      class="ra-diff-value ra-diff-value--current"
                      [ngClass]="getDiffTrendClass(item)"
                    >
                      {{ item.after ?? '—' }}
                    </span>
                    <em
                      *ngIf="item.delta != null"
                      class="ra-diff-delta"
                      [ngClass]="getDiffDeltaClass(item)"
                    >
                      {{ item.delta > 0 ? '+' : '' }}{{ item.delta }}
                    </em>
                  </div>
                  <div class="ra-diff-row__flags" *ngIf="item.before_flag || item.after_flag">
                    <span class="ra-flag" [ngClass]="'ra-flag--' + getMarkerFlagCssKey(item.before_flag)">{{ item.before_flag ? getMarkerFlagLabel(item.before_flag) : '—' }}</span>
                    <i class="pi pi-arrow-right"></i>
                    <span class="ra-flag" [ngClass]="'ra-flag--' + getMarkerFlagCssKey(item.after_flag)">{{ item.after_flag ? getMarkerFlagLabel(item.after_flag) : '—' }}</span>
                  </div>
                </div>
              </div>

              <div class="ra-diff-mini-grid">
                <div class="ra-diff-mini ra-diff-mini--added" *ngIf="display.diff.added.length">
                  <div class="ra-diff-mini__title"><i class="pi pi-plus-circle"></i> Added</div>
                  <div
                    class="ra-diff-mini__item"
                    *ngFor="let item of display.diff.added"
                    [ngClass]="getAddedMarkerTrendClass(item)"
                  >
                    <span>{{ item.marker_name }}</span>
                    <strong>{{ item.value_numeric ?? item.value_text ?? '—' }}</strong>
                    <span class="ra-flag" *ngIf="item.flag" [ngClass]="'ra-flag--' + getMarkerFlagCssKey(item.flag)">{{ getMarkerFlagLabel(item.flag) }}</span>
                  </div>
                </div>
                <div class="ra-diff-mini ra-diff-mini--removed" *ngIf="display.diff.removed.length">
                  <div class="ra-diff-mini__title"><i class="pi pi-minus-circle"></i> Removed</div>
                  <div class="ra-diff-mini__item" *ngFor="let item of display.diff.removed">
                    <span>{{ item.marker_name }}</span>
                    <strong>{{ item.value_numeric ?? item.value_text ?? '—' }}</strong>
                  </div>
                </div>
              </div>

              <div class="ra-diff-unchanged" *ngIf="display.diff.unchanged.length">
                <button type="button" class="ra-diff-unchanged__toggle" (click)="toggleUnchangedDiffMarkers()">
                  <i class="pi" [ngClass]="showUnchangedDiffMarkers ? 'pi-chevron-up' : 'pi-chevron-down'"></i>
                  {{ display.diff.unchanged.length }} unchanged markers
                </button>
                <div class="ra-diff-unchanged__list" *ngIf="showUnchangedDiffMarkers">
                  <div class="ra-diff-unchanged__item" *ngFor="let item of display.diff.unchanged">
                    <span>{{ item.marker_name }}</span>
                    <strong>{{ item.after ?? item.before ?? '—' }}</strong>
                  </div>
                </div>
              </div>
            </div>
          </ng-container>

          <div class="ra-empty-card" *ngIf="!reportCompareLoading && !comparisonDisplay">
            <i class="pi pi-chart-line"></i>
            <strong>No comparison yet</strong>
            <span>Pick a baseline report and run comparison to see deterministic marker changes with AI interpretation.</span>
          </div>
        </section>

        <section class="ra-panel" *ngIf="reportAnalysisTabIndex === 2 && analysisTabRenderReady">
          <div class="ra-outcome-banner">
            <i class="pi pi-shield"></i>
            <div>
              <strong>Decision support only</strong>
              <span>Uses non-causal language. Findings suggest possible response; they do not prove the remedy caused changes.</span>
            </div>
          </div>

          <div class="ra-treatment-context">
            <div class="ra-treatment-context__title">
              <i class="pi pi-user-edit"></i> Treatment context
            </div>
            <p>{{ treatmentContextSummary }}</p>
            <div class="ra-treatment-context__meta">
              <span class="ra-meta-pill">{{ getOutcomeContextLabel() }}</span>
            </div>
          </div>

          <div class="ra-baseline-summary">
            <div class="ra-baseline-summary__main">
              <span class="ra-baseline-summary__label">Baseline used</span>
              <strong>{{ getBaselineReportLabel() }}</strong>
              <span class="ra-baseline-summary__hint">
                Outcome reuses the same baseline as Comparison. Change it on the Comparison tab.
              </span>
            </div>
            <button
              type="button"
              class="ra-baseline-summary__link"
              (click)="setReportAnalysisTab(1)"
            >
              <i class="pi pi-chart-line"></i>
              Change baseline
            </button>
          </div>

          <div class="ra-cta ra-cta--outcome" *ngIf="aiEnabled">
            <div class="ra-cta__icon" aria-hidden="true">
              <i class="pi pi-heart"></i>
            </div>
            <div class="ra-cta__body">
              <div class="ra-cta__title">Treatment outcome analysis</div>
              <div class="ra-cta__hint">Links comparison diff, chief complaint, and prescription context.</div>
            </div>
            <button
              pButton
              type="button"
              class="ra-cta__btn ra-cta__btn--outcome"
              [loading]="reportOutcomeLoading"
              [disabled]="reportOutcomeLoading"
              (click)="runTreatmentOutcomeAnalysis()"
            >
              <i class="pi pi-heart" *ngIf="!reportOutcomeLoading"></i>
              <span>{{ reportOutcomeLoading ? 'Analyzing…' : 'Run Outcome' }}</span>
            </button>
          </div>

          <div class="ra-prereq-list" *ngIf="!outcomeDisplay && !reportOutcomeLoading">
            <div
              class="ra-prereq-item"
              *ngFor="let item of outcomePrerequisites"
              [class.ra-prereq-item--ok]="item.ok"
            >
              <i class="pi" [ngClass]="item.ok ? 'pi-check-circle' : 'pi-circle'"></i>
              <span>{{ item.label }}</span>
            </div>
          </div>

          <div class="ra-loading-card" *ngIf="reportOutcomeLoading">
            <i class="pi pi-spin pi-spinner"></i>
            <span>Building treatment outcome analysis…</span>
          </div>

          <ng-container *ngIf="!reportOutcomeLoading && outcomeDisplay as display">
            <div class="ra-outcome-hero">
              <div class="ra-outcome-hero__badge">
                <span class="ra-outcome-hero__label">Likely response</span>
                <span class="ra-response-chip ra-response-chip--xl" [ngClass]="display.likelyResponseClass">
                  {{ display.likelyResponse }}
                </span>
              </div>
              <div class="ra-outcome-hero__confidence">
                <div class="ra-metric__label">Confidence</div>
                <div class="ra-metric__value">{{ display.confidencePercent }}%</div>
                <div class="ra-confidence">
                  <div
                    class="ra-confidence__fill ra-confidence__fill--outcome"
                    [style.width.%]="display.confidencePercent"
                  ></div>
                </div>
              </div>
            </div>

            <div class="ra-insight-card ra-insight-card--outcome">
              <div class="ra-insight-card__head">
                <i class="pi pi-heart"></i>
                <span>Outcome summary</span>
              </div>
              <p>{{ display.summaryText }}</p>
            </div>

            <div class="ra-ask-ai" *ngIf="aiEnabled">
              <div class="ra-ask-ai__input-wrap">
                <i class="pi pi-sparkles ra-ask-ai__icon"></i>
                <input type="text" class="ra-ask-ai__input" placeholder="Ask Dr. Sanchiti AI about these results..." />
                <button type="button" class="ra-ask-ai__send" pTooltip="Coming Soon">
                  <i class="pi pi-send"></i>
                </button>
              </div>
            </div>

            <div class="ra-interpret-grid">
              <div class="ra-interpret-card" *ngIf="display.supportingChanges.length">
                <div class="ra-interpret-card__title">
                  <i class="pi pi-list"></i> Supporting observations
                </div>
                <ul>
                  <li *ngFor="let item of display.supportingChanges">{{ item }}</li>
                </ul>
              </div>
              <div class="ra-interpret-card ra-interpret-card--caveat" *ngIf="display.caveats.length">
                <div class="ra-interpret-card__title">
                  <i class="pi pi-info-circle"></i> Limitations
                </div>
                <ul>
                  <li *ngFor="let item of display.caveats">{{ item }}</li>
                </ul>
              </div>
            </div>

            <div class="ra-outcome-diff" *ngIf="display.diff as diff">
              <div class="ra-outcome-diff__title">
                <i class="pi pi-chart-bar"></i> Key marker changes considered
              </div>
              <div class="ra-diff-stats ra-diff-stats--compact">
                <div class="ra-diff-stat ra-diff-stat--changed">
                  <strong>{{ diff.stats.changed }}</strong>
                  <span>Changed</span>
                </div>
                <div class="ra-diff-stat ra-diff-stat--added">
                  <strong>{{ diff.stats.added }}</strong>
                  <span>Added</span>
                </div>
                <div class="ra-diff-stat ra-diff-stat--removed">
                  <strong>{{ diff.stats.removed }}</strong>
                  <span>Removed</span>
                </div>
              </div>
              <div class="ra-outcome-diff__list" *ngIf="display.changedPreview.length">
                <div
                  class="ra-outcome-diff__item"
                  *ngFor="let item of display.changedPreview"
                  [ngClass]="getDiffTrendClass(item)"
                  [pTooltip]="getDiffTrendTooltip(item)"
                  tooltipPosition="top"
                  appendTo="body"
                >
                  <span>{{ item.marker_name }}</span>
                  <div class="ra-outcome-diff__values">
                    <span>{{ item.before ?? '—' }}</span>
                    <span class="ra-diff-arrow ra-diff-arrow--sm" [ngClass]="getDiffTrendClass(item)">
                      <i [class]="getDiffDirectionIcon(item)"></i>
                    </span>
                    <strong>{{ item.after ?? '—' }}</strong>
                    <em
                      *ngIf="item.delta != null"
                      class="ra-diff-delta"
                      [ngClass]="getDiffDeltaClass(item)"
                    >
                      {{ item.delta > 0 ? '+' : '' }}{{ item.delta }}
                    </em>
                    <span class="ra-diff-trend-chip ra-diff-trend-chip--sm" [ngClass]="getDiffTrendClass(item)">
                      {{ getDiffTrendLabel(item) }}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </ng-container>

          <div class="ra-empty-card" *ngIf="!reportOutcomeLoading && !outcomeDisplay">
            <i class="pi pi-heart"></i>
            <strong>No outcome analysis yet</strong>
            <span>Select a patient, analyze the current report, then run outcome analysis using the consultation context.</span>
          </div>
        </section>
      </div>
    </main>
  </div>

  <ng-template pTemplate="footer">
    <div class="ra-footer" *ngIf="selectedReportFile">
      <div class="ra-footer__copy">
        <label for="doctorReviewNotes">Doctor Review Notes</label>
        <span>Visible on the active analysis record.</span>
      </div>
      <div class="ra-footer__actions">
        <textarea
          id="doctorReviewNotes"
          rows="2"
          class="ra-footer__textarea"
          placeholder="Add clinical review notes or override comments…"
          [(ngModel)]="doctorReviewNotes"
        ></textarea>
        <button
          type="button"
          class="ra-footer__save-btn"
          [disabled]="reportReviewSaving || !canSaveAnalysisReview()"
          (click)="saveAnalysisReview()"
        >
          <i class="pi" [ngClass]="reportReviewSaving ? 'pi-spin pi-spinner' : 'pi-check'"></i>
          <span>{{ reportReviewSaving ? 'Saving…' : 'Save Review' }}</span>
        </button>
      </div>
    </div>
  </ng-template>
</p-dialog>

<p-dialog
  [(visible)]="textReportViewerVisible"
  [modal]="true"
  [style]="{ width: 'min(92vw, 720px)' }"
  [contentStyle]="{ padding: '0', overflow: 'hidden', display: 'flex', flexDirection: 'column', minHeight: '0' }"
  [draggable]="false"
  [resizable]="false"
  styleClass="trv-dialog"
  (onHide)="closeTextReportViewer()"
>
  <ng-template pTemplate="header">
    <div class="trv-head" *ngIf="viewingTextReport">
      <div class="trv-head__icon"><i class="pi pi-file-edit"></i></div>
      <div class="trv-head__copy">
        <span class="trv-head__eyebrow">Text report</span>
        <h2 class="trv-head__title">{{ viewingTextReport.name || 'Untitled report' }}</h2>
        <p class="trv-head__meta">
          <span *ngIf="viewingTextReport.uploaded_at">
            <i class="pi pi-calendar"></i> {{ viewingTextReport.uploaded_at }}
          </span>
          <span>
            <i class="pi pi-align-left"></i>
            {{ getTextReportLineCount(viewingTextReport) }} line{{ getTextReportLineCount(viewingTextReport) === 1 ? '' : 's' }}
          </span>
        </p>
      </div>
    </div>
  </ng-template>

  <div class="trv-body" *ngIf="viewingTextReport">
    <div class="trv-loading" *ngIf="textReportViewerLoading">
      <i class="pi pi-spin pi-spinner"></i>
      <span>Loading report…</span>
    </div>
    <div class="trv-content" *ngIf="!textReportViewerLoading">
      {{ getTextReportBody(viewingTextReport) }}
    </div>
  </div>

  <ng-template pTemplate="footer">
    <div class="trv-footer">
      <button type="button" class="pc-btn pc-btn--ghost" (click)="copyTextReportContent()">
        <i class="pi pi-copy"></i> Copy text
      </button>
      <div class="trv-footer__actions">
        <button
          type="button"
          class="pc-btn pc-btn--ghost"
          *ngIf="aiEnabled && viewingTextReport?.id"
          (click)="openTextReportAnalysisFromViewer()"
        >
          <i class="pi pi-sparkles"></i> AI analysis
        </button>
        <button type="button" class="pc-btn pc-btn--primary" (click)="closeTextReportViewer()">
          Close
        </button>
      </div>
    </div>
  </ng-template>
</p-dialog>

<app-photo-progress-compare-dialog
  [(visible)]="imageCompareDialogVisible"
  [beforePhotos]="imageCompareBefore"
  [afterPhotos]="imageCompareAfter"
  [aiEnabled]="aiEnabled"
  [prescriptionId]="(prescription?.id > 0 ? prescription.id : null)"
  [chiefComplaints]="getPhotoProgressChiefComplaints()"
  [diagnoses]="getPhotoProgressDiagnoses()"
  [treatmentContext]="getPhotoProgressTreatmentContext()"
  [patientExportLabel]="getPatientExportLabel()"
  [initialAnalysis]="photoProgressInitialAnalysis"
  (analysisSaved)="onPhotoProgressAnalysisSaved($event)"
></app-photo-progress-compare-dialog>

<p-confirmPopup key="reportDeleteConfirm"></p-confirmPopup>
<p-confirmPopup key="saveCaseConfirmPopup"></p-confirmPopup>
